webpackJsonp([14],{

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 328,
	"./af.js": 328,
	"./ar": 335,
	"./ar-dz": 329,
	"./ar-dz.js": 329,
	"./ar-kw": 330,
	"./ar-kw.js": 330,
	"./ar-ly": 331,
	"./ar-ly.js": 331,
	"./ar-ma": 332,
	"./ar-ma.js": 332,
	"./ar-sa": 333,
	"./ar-sa.js": 333,
	"./ar-tn": 334,
	"./ar-tn.js": 334,
	"./ar.js": 335,
	"./az": 336,
	"./az.js": 336,
	"./be": 337,
	"./be.js": 337,
	"./bg": 338,
	"./bg.js": 338,
	"./bm": 339,
	"./bm.js": 339,
	"./bn": 340,
	"./bn.js": 340,
	"./bo": 341,
	"./bo.js": 341,
	"./br": 342,
	"./br.js": 342,
	"./bs": 343,
	"./bs.js": 343,
	"./ca": 344,
	"./ca.js": 344,
	"./cs": 345,
	"./cs.js": 345,
	"./cv": 346,
	"./cv.js": 346,
	"./cy": 347,
	"./cy.js": 347,
	"./da": 348,
	"./da.js": 348,
	"./de": 351,
	"./de-at": 349,
	"./de-at.js": 349,
	"./de-ch": 350,
	"./de-ch.js": 350,
	"./de.js": 351,
	"./dv": 352,
	"./dv.js": 352,
	"./el": 353,
	"./el.js": 353,
	"./en-au": 354,
	"./en-au.js": 354,
	"./en-ca": 355,
	"./en-ca.js": 355,
	"./en-gb": 356,
	"./en-gb.js": 356,
	"./en-ie": 357,
	"./en-ie.js": 357,
	"./en-il": 358,
	"./en-il.js": 358,
	"./en-nz": 359,
	"./en-nz.js": 359,
	"./eo": 360,
	"./eo.js": 360,
	"./es": 363,
	"./es-do": 361,
	"./es-do.js": 361,
	"./es-us": 362,
	"./es-us.js": 362,
	"./es.js": 363,
	"./et": 364,
	"./et.js": 364,
	"./eu": 365,
	"./eu.js": 365,
	"./fa": 366,
	"./fa.js": 366,
	"./fi": 367,
	"./fi.js": 367,
	"./fo": 368,
	"./fo.js": 368,
	"./fr": 371,
	"./fr-ca": 369,
	"./fr-ca.js": 369,
	"./fr-ch": 370,
	"./fr-ch.js": 370,
	"./fr.js": 371,
	"./fy": 372,
	"./fy.js": 372,
	"./gd": 373,
	"./gd.js": 373,
	"./gl": 374,
	"./gl.js": 374,
	"./gom-latn": 375,
	"./gom-latn.js": 375,
	"./gu": 376,
	"./gu.js": 376,
	"./he": 377,
	"./he.js": 377,
	"./hi": 378,
	"./hi.js": 378,
	"./hr": 379,
	"./hr.js": 379,
	"./hu": 380,
	"./hu.js": 380,
	"./hy-am": 381,
	"./hy-am.js": 381,
	"./id": 382,
	"./id.js": 382,
	"./is": 383,
	"./is.js": 383,
	"./it": 384,
	"./it.js": 384,
	"./ja": 385,
	"./ja.js": 385,
	"./jv": 386,
	"./jv.js": 386,
	"./ka": 387,
	"./ka.js": 387,
	"./kk": 388,
	"./kk.js": 388,
	"./km": 389,
	"./km.js": 389,
	"./kn": 390,
	"./kn.js": 390,
	"./ko": 391,
	"./ko.js": 391,
	"./ky": 392,
	"./ky.js": 392,
	"./lb": 393,
	"./lb.js": 393,
	"./lo": 394,
	"./lo.js": 394,
	"./lt": 395,
	"./lt.js": 395,
	"./lv": 396,
	"./lv.js": 396,
	"./me": 397,
	"./me.js": 397,
	"./mi": 398,
	"./mi.js": 398,
	"./mk": 399,
	"./mk.js": 399,
	"./ml": 400,
	"./ml.js": 400,
	"./mn": 401,
	"./mn.js": 401,
	"./mr": 402,
	"./mr.js": 402,
	"./ms": 404,
	"./ms-my": 403,
	"./ms-my.js": 403,
	"./ms.js": 404,
	"./mt": 405,
	"./mt.js": 405,
	"./my": 406,
	"./my.js": 406,
	"./nb": 407,
	"./nb.js": 407,
	"./ne": 408,
	"./ne.js": 408,
	"./nl": 410,
	"./nl-be": 409,
	"./nl-be.js": 409,
	"./nl.js": 410,
	"./nn": 411,
	"./nn.js": 411,
	"./pa-in": 412,
	"./pa-in.js": 412,
	"./pl": 413,
	"./pl.js": 413,
	"./pt": 415,
	"./pt-br": 414,
	"./pt-br.js": 414,
	"./pt.js": 415,
	"./ro": 416,
	"./ro.js": 416,
	"./ru": 417,
	"./ru.js": 417,
	"./sd": 418,
	"./sd.js": 418,
	"./se": 419,
	"./se.js": 419,
	"./si": 420,
	"./si.js": 420,
	"./sk": 421,
	"./sk.js": 421,
	"./sl": 422,
	"./sl.js": 422,
	"./sq": 423,
	"./sq.js": 423,
	"./sr": 425,
	"./sr-cyrl": 424,
	"./sr-cyrl.js": 424,
	"./sr.js": 425,
	"./ss": 426,
	"./ss.js": 426,
	"./sv": 427,
	"./sv.js": 427,
	"./sw": 428,
	"./sw.js": 428,
	"./ta": 429,
	"./ta.js": 429,
	"./te": 430,
	"./te.js": 430,
	"./tet": 431,
	"./tet.js": 431,
	"./tg": 432,
	"./tg.js": 432,
	"./th": 433,
	"./th.js": 433,
	"./tl-ph": 434,
	"./tl-ph.js": 434,
	"./tlh": 435,
	"./tlh.js": 435,
	"./tr": 436,
	"./tr.js": 436,
	"./tzl": 437,
	"./tzl.js": 437,
	"./tzm": 439,
	"./tzm-latn": 438,
	"./tzm-latn.js": 438,
	"./tzm.js": 439,
	"./ug-cn": 440,
	"./ug-cn.js": 440,
	"./uk": 441,
	"./uk.js": 441,
	"./ur": 442,
	"./ur.js": 442,
	"./uz": 444,
	"./uz-latn": 443,
	"./uz-latn.js": 443,
	"./uz.js": 444,
	"./vi": 445,
	"./vi.js": 445,
	"./x-pseudo": 446,
	"./x-pseudo.js": 446,
	"./yo": 447,
	"./yo.js": 447,
	"./zh-cn": 448,
	"./zh-cn.js": 448,
	"./zh-hk": 449,
	"./zh-hk.js": 449,
	"./zh-tw": 450,
	"./zh-tw.js": 450
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1001;

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var Component = __webpack_require__(100)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1016),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('md-whiteframe', {
    staticClass: "main-header topnav",
    attrs: {
      "md-tag": "md-toolbar",
      "md-elevation": "1"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button nav-trigger",
    on: {
      "click": _vm.toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "align": "center",
      "id": "title"
    }
  }, [_vm._v(" \n      " + _vm._s(_vm.softwareTitle) + "  \n    ")]), _vm._v(" "), _c('md-menu', {
    ref: "langCard",
    attrs: {
      "md-size": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-button md-sqlang",
    attrs: {
      "id": "langButton",
      "md-menu-trigger": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.local) + "\n        "), _c('md-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('md-menu-content', {
    staticClass: "langMenu"
  }, [_c('md-menu-item', {
    attrs: {
      "md-active": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.setLocale('es')
      }
    }
  }, [_c('md-radio', {
    attrs: {
      "id": "my-test1",
      "name": "idiomaGroup",
      "md-value": "es"
    },
    model: {
      value: (_vm.local),
      callback: function($$v) {
        _vm.local = $$v
      },
      expression: "local"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~ESPANOL~')))])], 1), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.setLocale('en')
      }
    }
  }, [_c('md-radio', {
    attrs: {
      "id": "my-test2",
      "name": "idiomaGroup",
      "md-value": "en"
    },
    model: {
      value: (_vm.local),
      callback: function($$v) {
        _vm.local = $$v
      },
      expression: "local"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~INGLES~')))])], 1), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.setLocale('pt')
      }
    }
  }, [_c('md-radio', {
    attrs: {
      "id": "my-test3",
      "name": "idiomaGroup",
      "md-value": "pt"
    },
    model: {
      value: (_vm.local),
      callback: function($$v) {
        _vm.local = $$v
      },
      expression: "local"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~PORTUGUES~')))])], 1)], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button help-button",
    nativeOn: {
      "click": function($event) {
        return _vm.activeHelp($event)
      }
    }
  }, [_c('md-icon', {
    class: {
      'custom-color-active': _vm.isActiveHelp, 'custom-color': !_vm.isActiveHelp
    }
  }, [_vm._v("live_help")]), _vm._v(" "), (_vm.isActiveHelp) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("\n        " + _vm._s(_vm._f("translate")('global.~DESACTIVAR~')) + "\n      ")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("\n        " + _vm._s(_vm._f("translate")('global.~ACTIVAR~')) + "\n      ")])], 1)], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('main-footer', {
    attrs: {
      "name": _vm.softwareTitle
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', {
    staticClass: "custom-footer",
    attrs: {
      "md-align": "end",
      "md-flex": "100"
    }
  }, [_vm._v("\n" + _vm._s(_vm.softwareName) + "\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "main-sidebar",
    staticClass: "main-sidebar md-left md-fixed",
    attrs: {
      "md-swipeable": ""
    }
  }, [_c('md-toolbar', {
    staticClass: "vue-material-logo logo-main",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingLogo),
      expression: "!loadingLogo"
    }],
    attrs: {
      "exact": "",
      "to": "/admin"
    }
  }, [_c('img', {
    staticClass: "logo-main",
    attrs: {
      "src": _vm.logoOrganization
    }
  })]), _vm._v(" "), (_vm.loadingLogo) ? _c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('md-spinner', {
    staticClass: "md-accent custom-spinner",
    attrs: {
      "md-size": 40,
      "md-indeterminate": ""
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "main-sidebar-links"
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "user-info"
  }, [_c('md-avatar', {
    staticClass: "md-avatar-icon"
  }, [_c('md-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentUserName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.currentUser.position)) + " "), _c('small', [_vm._v("(" + _vm._s(_vm.currentUser.idCard) + ")")])])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-dense md-icon-button md-list-action logout-button",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.logout()
      }
    }
  }, [_c('md-icon', {
    staticClass: "custom-icon md-accent"
  }, [_vm._v("power_settings_new")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~SALIR~')))])], 1), _vm._v(" "), _c('md-divider')], 1)], 1), _vm._v(" "), _c('md-subheader', [_vm._v(_vm._s(_vm._f("translate")('organization.~TITULO~')))]), _vm._v(" "), _c('div', {
    staticClass: "custom-box organization"
  }, [_c('multiselect', {
    staticClass: "custom-multiselect",
    attrs: {
      "maxHeight": 400,
      "options": _vm.orgSmallList,
      "custom-label": _vm.customLabel,
      "placeholder": _vm._f("translate")('users.~BUSCAR~'),
      "selectLabel": "",
      "selectedLabel": _vm._f("translate")('organization.~SELECCIONADO~'),
      "label": "name",
      "track-by": "id",
      "allow-empty": true,
      "hide-selected": false
    },
    model: {
      value: (_vm.currentOrgId),
      callback: function($$v) {
        _vm.currentOrgId = $$v
      },
      expression: "currentOrgId"
    }
  })], 1), _vm._v(" "), _c('md-list', _vm._l((_vm.items), function(item, index) {
    return _c('md-list-item', {
      key: index,
      class: item.name
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "to": item.to
      }
    }, [_c('md-icon', [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("translate")(item.title)))])], 1), _vm._v(" "), (item.subitems) ? _c('md-list-expand', [_c('md-list', _vm._l((item.subitems), function(subitem, index) {
      return _c('md-list-item', {
        key: index,
        staticClass: "md-inset"
      }, [_c('router-link', {
        attrs: {
          "exact": "",
          "to": subitem.to
        }
      }, [_c('md-icon', [_vm._v(_vm._s(item.icon))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)], 1)
    }))], 1) : _vm._e()], 1)
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: this.currentOrgId
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar2",
    attrs: {
      "md-position": 'bottom right',
      "md-duration": 6000
    }
  }, [_vm._l((_vm.snackbar.errors), function(item) {
    return _c('span', {
      key: item
    }, [_vm._v(" " + _vm._s(item.message))])
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Ok")])], 2), _vm._v(" "), _c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": _vm.vertical + ' ' + _vm.horizontal,
      "md-duration": _vm.duration
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")(_vm.sMessage)) + ".")]), _vm._v(" "), _c('md-button', {
    class: _vm.snackbarStyle,
    on: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Ok")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "confirmMessage",
    attrs: {
      "md-title": _vm._f("translate")('global.~ALERTA~'),
      "md-content-html": _vm._f("translate")(_vm.dMessage),
      "md-ok-text": _vm._f("translate")('global.~ACEPTAR~'),
      "md-cancel-text": _vm._f("translate")('global.~CANCELAR~')
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "dialogAlert",
    attrs: {
      "md-title": _vm._f("translate")('global.~ALERTA~'),
      "md-content": _vm._f("translate")(_vm.dMessage),
      "md-ok-text": _vm._f("translate")('global.~ACEPTAR~')
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);




var Login = function Login() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1042));
};
var Admin = function Admin() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1032));
};
var AdminDashboard = function AdminDashboard() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1037));
};
var AdminCampaigns = function AdminCampaigns() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1033));
};
var AdminOpenCampaigns = function AdminOpenCampaigns() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1035));
};
var AdminOrganizations = function AdminOrganizations() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1038));
};
var AdminSubscriberDb = function AdminSubscriberDb() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1040));
};
var AdminUsers = function AdminUsers() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1041));
};
var AdminReports = function AdminReports() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1036));
};
var AdminSettings = function AdminSettings() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1039));
};
var AdminCampaignForm = function AdminCampaignForm() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1034));
};
var CurrentStep = function CurrentStep() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1030));
};
var Recovery = function Recovery() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1031));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function requireAuth(to, from, next) {
  var token = localStorage.getItem('feathers-jwt');
  if (token && __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(token).exp) {
    var exp = new Date(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(token).exp * 1000);
    if (exp < new Date()) {
      localStorage.removeItem('feathers-jwt');
      delete __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'];
      token = null;
    }
  }

  var query = { redirect: to.path };
  if (to.query.hl) {
    query.hl = to.query.hl;
  }

  if (!token) {
    next({
      path: '/login',
      query: query
    });
  } else {
    next();
  }
}

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/admin'
  }, {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/admin',
    component: Admin,
    beforeEnter: requireAuth,
    children: [{
      path: '/',
      name: 'adminDashboard',
      component: AdminDashboard
    }, {
      path: 'organizations/',
      name: 'adminOrganizations',
      component: AdminOrganizations,
      props: true
    }, {
      path: 'organizations/:type/new',
      name: 'adminOrganizationForm',
      component: AdminOrganizations,
      props: true
    }, {
      path: 'organizations/:id/:type/edit',
      name: 'adminOrganizationEdit',
      component: AdminOrganizations,
      props: true
    }, {
      path: 'subscribersdb',
      name: 'adminSubscriberDb',
      component: AdminSubscriberDb,
      props: true
    }, {
      path: 'subscribersdb/:type/new',
      name: 'adminSubscriberDbForm',
      component: AdminSubscriberDb,
      props: true
    }, {
      path: 'subscribersdb/:id/:type/edit',
      name: 'adminSubscriberDbEdit',
      component: AdminSubscriberDb,
      props: true
    }, {
      path: 'users/',
      name: 'adminUsers',
      component: AdminUsers,
      props: true
    }, {
      path: 'users/:type/new',
      name: 'adminUserForm',
      component: AdminUsers,
      props: true
    }, {
      path: 'users/:id/:type/edit',
      name: 'adminUserEdit',
      component: AdminUsers,
      props: true
    }, {
      path: 'campaigns',
      name: 'adminCampaigns',
      component: AdminCampaigns
    }, {
      path: 'campaigns/:id/reports/:dbid/:currentPage/:pageSize/:searchTerm?',
      name: 'adminReports',
      component: AdminReports,
      props: true
    }, {
      path: 'campaigns/new',
      component: AdminCampaignForm,
      children: [{
        path: ':_id',
        name: 'currentStep',
        component: CurrentStep
      }]
    }, {
      path: 'campaigns/:id/edit',
      component: AdminCampaignForm,
      children: [{
        path: ':_id',
        name: 'editCurrentStep',
        component: CurrentStep
      }]
    }, {
      path: 'opencampaigns',
      name: 'openCampaigns',
      component: AdminOpenCampaigns
    }, {
      path: 'settings',
      name: 'adminSettings',
      component: AdminSettings
    }]
  }, {
    path: '/users/:userId/resetlink/:rlink',
    name: 'recovery',
    component: Recovery,
    props: true
  }]
});

router.beforeEach(function (to, from, next) {
  // use the language from the routing param or default language
  var language = to.query.hl;
  if (language) {
    console.log(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set.toString());
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set(language);
  }
  // set the current language for vuex-i18n. note that translation data
  // for the language might need to be loaded first
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESET_CURRENT_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RESET_CAMPAIGNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return RESET_ORG_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_ORG_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RESET_USER_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return RESET_SDB_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return RESET_FILE_STATE; });
/* unused harmony export LIST_CAMPAIGNS */
/* unused harmony export LIST_CAMPAIGNS_SUCCEEDED */
/* unused harmony export LIST_CAMPAIGNS_FAILED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_CAMPAIGN_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_DIALPLAN_FROM_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_DIALPLAN_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DIALPLAN_CURRENT_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_DIALPLAN_NEXT_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_DIALPLAN_INPUT; });
/* unused harmony export UPDATE_DIALPLAN_TREE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return LOGIN_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return LOGIN_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return LOGIN_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return RESET_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return RESET_CURRENT_USER_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_CURRENT_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_GLOBAL_LOGO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_GLOBAL_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_CURRENT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_CURRENT_USER_ORGID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_USER_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_USER_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SET_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return TMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_CURRENT_CAMPAIGN; });
/* unused harmony export SET_DUPLICATE_CAMPAIGN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_DB_VARIABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RESET_TOUR_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_CURRENT_TOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CHANGE_ACTIVE_HELP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_CURRENT_TOUR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_VIEWED_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ADD_AUDIO_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REMOVE_AUDIO_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_AUDIO_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_AUDIO_FILES_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_AUDIO_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_AUDIO_FILES_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_AUDIO_FILES_ERROR; });
var RESET_CURRENT_CAMPAIGN = 'RESET_CURRENT_CAMPAIGN';
var RESET_CAMPAIGNS = 'RESET_CAMPAIGNS';
var RESET_ORG_STATE = 'RESET_ORG_STATE';
var RESET_ORG_CURRENT = 'RESET_ORG_CURRENT';
var RESET_USER_STATE = 'RESET_USER_STATE';
var RESET_SDB_STATE = 'RESET_SDB_STATE';
var RESET_FILE_STATE = 'RESET_FILE_STATE';

var LIST_CAMPAIGNS = 'LIST_CAMPAIGNS';
var LIST_CAMPAIGNS_SUCCEEDED = 'LIST_CAMPAIGNS_SUCCEEDED';
var LIST_CAMPAIGNS_FAILED = 'LIST_CAMPAIGNS_FAILED';

var SET_CAMPAIGN_PLAN = 'SET_CAMPAIGN_PLAN';

var SET_DIALPLAN_FROM_STEP = 'SET_DIALPLAN_FROM_STEP';
var RESET_DIALPLAN_STATE = 'RESET_DIALPLAN_STATE';
var SET_DIALPLAN_CURRENT_STEP = 'SET_DIALPLAN_CURRENT_STEP';
var SET_DIALPLAN_NEXT_STEP = 'SET_DIALPLAN_NEXT_STEP';
var SET_DIALPLAN_INPUT = 'SET_DIALPLAN_INPUT';
var UPDATE_DIALPLAN_TREE = 'UPDATE_DIALPLAN_TREE';

var LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
var LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
var LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
var RESET_CURRENT_USER = 'RESET_CURRENT_USER';
var RESET_CURRENT_USER_LOADING = 'RESET_CURRENT_USER_LOADING';
var SET_CURRENT_USER = 'SET_CURRENT_USER';
var SET_CURRENT_LOGO = 'SET_CURRENT_LOGO';
var SET_GLOBAL_LOGO = 'SET_GLOBAL_LOGO';
var SET_GLOBAL_TITLE = 'SET_GLOBAL_TITLE';

var SET_CURRENT_TITLE = 'SET_CURRENT_TITLE';
var SET_CURRENT_USER_ORGID = 'SET_CURRENT_USER_ORGID';
var SET_USER_ROLES = 'TRANSFORM_USER_ROLES';
var RESET_USER_CURRENT = 'RESET_USER_CURRENT';
var SET_ROLES = 'SET_ROLES';
var TMP = 'TMP';
var SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN';
var SET_DUPLICATE_CAMPAIGN = 'SET_DUPLICATE_CAMPAIGN';
var SET_DB_VARIABLES = 'SET_DB_VARIABLES';

var RESET_TOUR_STATE = 'RESET_TOUR_STATE';
var UPDATE_CURRENT_TOUR = 'UPDATE_CURRENT_TOUR';
var CHANGE_ACTIVE_HELP = 'CHANGE_ACTIVE_HELP';
var UPDATE_CURRENT_TOUR_DATA = 'UPDATE_CURRENT_TOUR_DATA';
var SET_VIEWED_VALUE = 'SET_VIEWED_VALUE';

var ADD_AUDIO_FILE = 'ADD_AUDIO_FILE';
var REMOVE_AUDIO_FILE = 'REMOVE_AUDIO_FILE';
var SET_AUDIO_FILES = 'SET_AUDIO_FILES';
var SET_AUDIO_FILES_ADDED = 'SET_AUDIO_FILES_ADDED';
var RESET_AUDIO_FILES = 'RESET_AUDIO_FILES';
var SET_AUDIO_FILES_LOADING = 'SET_AUDIO_FILES_LOADING';
var SET_AUDIO_FILES_ERROR = 'SET_AUDIO_FILES_ERROR';

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_i18n__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_authentication__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_user__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_tour__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_organization__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_campaign__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_audiofile__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_dialplan__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_subscriber_db__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_file__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_vcc_conf__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex_persistedstate__ = __webpack_require__(1021);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    i18n: __WEBPACK_IMPORTED_MODULE_2__modules_i18n__["a" /* default */],
    authentication: __WEBPACK_IMPORTED_MODULE_3__modules_authentication__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_4__modules_user__["a" /* default */],
    tour: __WEBPACK_IMPORTED_MODULE_5__modules_tour__["a" /* default */],
    organization: __WEBPACK_IMPORTED_MODULE_6__modules_organization__["a" /* default */],
    subscriberDb: __WEBPACK_IMPORTED_MODULE_10__modules_subscriber_db__["a" /* default */],
    campaign: __WEBPACK_IMPORTED_MODULE_7__modules_campaign__["a" /* default */],
    file: __WEBPACK_IMPORTED_MODULE_11__modules_file__["a" /* default */],
    dialplan: __WEBPACK_IMPORTED_MODULE_9__modules_dialplan__["a" /* default */],
    audiofile: __WEBPACK_IMPORTED_MODULE_8__modules_audiofile__["a" /* default */],
    vccConf: __WEBPACK_IMPORTED_MODULE_12__modules_vcc_conf__["a" /* default */]
  },
  strict: debug,
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex_persistedstate__["a" /* default */])({ paths: ['authentication'] })]
}));

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return encodeQueryData; });
/* unused harmony export mapProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapStateObjectProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return transformPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return paginateList; });
/* unused harmony export setNullIfEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pForever; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return countries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return countries2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);








var _this = this;



var isReallyEmpty = function isReallyEmpty(x) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isNil"])(x) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isNumber"])(x) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isBoolean"])(x) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(x);
};

var encodeQueryData = function encodeQueryData(data) {
  var ret = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["map"])(data, function (value, key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  });
  return ret.join('&');
};

var mapProperties = function mapProperties(objName, names, mutationName, mutationPayloadAttrName) {
  var result = {};

  names.map(function (item) {
    result[item] = {
      get: function get() {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(this, objName + '.' + item);
      },
      set: function set(value) {
        var newObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["assign"])({}, this[objName], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["set"])({}, item, value));
        this.$store.commit(mutationName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["set"])({}, mutationPayloadAttrName, newObj));
      }
    };
  });

  return result;
};

var mapStateObjectProps = function mapStateObjectProps(_ref) {
  var stateName = _ref.stateName,
      objectName = _ref.objectName,
      properties = _ref.properties,
      mutationName = _ref.mutationName,
      payloadAttrName = _ref.payloadAttrName;

  var result = {};

  properties.map(function (item) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["set"])(result, item, {
      get: function get() {
        return stateName ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(this.$store.state, stateName + '.' + item) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(this, objectName + '.' + item);
      },
      set: function set(value) {
        var object = stateName ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(this.$store.state, stateName) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["get"])(this, objectName);
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["assign"])({}, object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["set"])({}, item, value)));
        this.$store.commit(mutationName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["set"])({}, payloadAttrName, data));
      }
    });
  });
  return result;
};

var transformPlan = function transformPlan(tree) {
  if (tree) {
    return { initialStep: function recurse(currentStep) {
        var json = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["cloneDeep"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(currentStep, 'input', 'step', 'id', 'parentId'));
        var tmp = {
          Hangup: {
            type: 'SimpleAction',
            action: 'hangup'
          },
          Begin: {
            type: 'SimpleAction',
            action: 'begin'
          },
          Return: {
            type: 'SimpleAction',
            action: 'return'
          },
          Repeat: {
            type: 'SimpleAction',
            action: 'repeat'
          }
        }[json.type];
        if (tmp) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["assign"])(json, tmp);
        if (currentStep.step) {
          json.step = recurse(currentStep.step);
        } else if (currentStep.input) {
          json.input = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omit"])(currentStep.input, 'choices');
          json.input.choices = currentStep.input.choices.map(recurse);
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["omitBy"])(json, isReallyEmpty);
      }(tree.initialStep) };
  }
};

var paginateList = function paginateList(mainList, currentPage, size) {
  var arry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["chunk"])(mainList, size);
  var current = currentPage;
  if (arry.length < current) {
    current = arry.length;
  }
  return { result: arry[current - 1], currentPage: current };
};

var setNullIfEmpty = function setNullIfEmpty(obj, props) {
  var zero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (obj && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash__["isArray"])(props)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(props), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var prop = _step.value;

        obj[prop] = obj[prop] === '' || zero && obj[prop] === 0 ? null : obj[prop];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

var pMap = function pMap(iterable, mapper, options) {
  return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    options = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({
      concurrency: Infinity
    }, options);

    if (typeof mapper !== 'function') {
      throw new TypeError('Mapper function is required');
    }

    var _options = options,
        concurrency = _options.concurrency;


    if (!(typeof concurrency === 'number' && concurrency >= 1)) {
      throw new TypeError('Expected `concurrency` to be a number from 1 and up, got `' + concurrency + '` (' + (typeof concurrency === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(concurrency)) + ')');
    }

    var ret = [];
    var iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(iterable);
    var isRejected = false;
    var isIterableDone = false;
    var resolvingCount = 0;
    var currentIndex = 0;

    var next = function next() {
      if (isRejected) {
        return;
      }

      var nextItem = iterator.next();
      var i = currentIndex;
      currentIndex++;

      if (nextItem.done) {
        isIterableDone = true;

        if (resolvingCount === 0) {
          resolve(ret);
        }

        return;
      }

      resolvingCount++;

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a.resolve(nextItem.value).then(function (element) {
        return mapper(element, i);
      }).then(function (value) {
        ret[i] = value;
        resolvingCount--;
        next();
      }, function (error) {
        isRejected = true;
        reject(error);
      });
    };

    for (var i = 0; i < concurrency; i++) {
      next();

      if (isIterableDone) {
        break;
      }
    }
  });
};

var symbolEnd = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default()('pForever.end');
var pForever = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fn, previousValue) {
    var newValue;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = fn;
            _context.next = 3;
            return previousValue;

          case 3:
            _context.t1 = _context.sent;
            _context.next = 6;
            return (0, _context.t0)(_context.t1);

          case 6:
            newValue = _context.sent;

            if (!(newValue === symbolEnd)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return');

          case 9:
            return _context.abrupt('return', pForever(fn, newValue));

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function pForever(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

pForever.end = symbolEnd;



var countries = [{ name: 'USA', code: 'US' }, { name: 'Colombia', code: 'CO' }, { name: 'México', code: 'MX' }];

var countries2 = [{ name: 'Colombia', code: 'CO' }, { name: 'México', code: 'MX' }, { name: 'Costa Rica', code: 'CR' }, { name: 'Honduras', code: 'HN' }, { name: 'República Dominicana', code: 'DO' }, { name: 'Panamá', code: 'PA' }, { name: 'Perú', code: 'PE' }, { name: 'Guatemala', code: 'GT' }, { name: 'Nicaragua', code: 'NI' }, { name: 'El Salvador', code: 'SV' }, { name: 'USA', code: 'US' }];

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = base64ArrayBuffer;
// Converts an ArrayBuffer directly to base64, without any intermediate 'convert to string then
// use window.btoa' step. According to my tests, this appears to be a faster approach:
// http://jsperf.com/encoding-xhr-image-data/5

/*
MIT LICENSE

Copyright 2011 Jon Leighton

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

function base64ArrayBuffer(arrayBuffer) {
  var base64 = '';
  var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

  var bytes = new Uint8Array(arrayBuffer);
  var byteLength = bytes.byteLength;
  var byteRemainder = byteLength % 3;
  var mainLength = byteLength - byteRemainder;

  var a, b, c, d;
  var chunk;

  // Main loop deals with bytes in chunks of 3
  for (var i = 0; i < mainLength; i = i + 3) {
    // Combine the three bytes into a single integer
    chunk = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];

    // Use bitmasks to extract 6-bit segments from the triplet
    a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
    b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
    c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
    d = chunk & 63; // 63       = 2^6 - 1

    // Convert the raw binary segments to the appropriate ASCII encoding
    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
  }

  // Deal with the remaining bytes and padding
  if (byteRemainder === 1) {
    chunk = bytes[mainLength];

    a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

    // Set the 4 least significant bits to zero
    b = (chunk & 3) << 4; // 3   = 2^2 - 1

    base64 += encodings[a] + encodings[b] + '==';
  } else if (byteRemainder === 2) {
    chunk = bytes[mainLength] << 8 | bytes[mainLength + 1];

    a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
    b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

    // Set the 2 least significant bits to zero
    c = (chunk & 15) << 2; // 15    = 2^4 - 1

    base64 += encodings[a] + encodings[b] + encodings[c] + '=';
  }

  return base64;
}

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(100)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1017),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a7c2638c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STEP_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WAIT_TIME_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RETRY_TIME_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLogo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios_retry__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios_retry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios_retry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





// const backendBaseURL = 'https://api.vcc.ipcomnetwork.net/'
var backendBaseURL = 'https://api.vcc-next.ipcom.ai/';

// const backendBaseURL = 'http://127.0.0.1:3030'
var wsBaseURL = 'wss://api.vcc-next.ipcom.ai/wss';

var STEP_TYPES = {
  TTS: 1,
  Playback: 2,
  WebVariable: 3,
  Record: 4,
  SimpleAction: 5,
  RecordDigits: 6,
  Transfer: 7,
  Hangup: 8,
  Return: 9,
  Begin: 10,
  Repeat: 11,
  ASRStep: 12,
  Delay: 13,
  properties: {
    1: { name: 'Text to Speech', value: 1, code: 'TTS' },
    2: { name: 'Playback', value: 2, code: 'Playback' },
    3: { name: 'Web Variable', value: 3, code: 'WebVariable' },
    4: { name: 'Record', value: 4, code: 'Record' },
    5: { name: 'Simple Action', value: 5, code: 'SimpleAction' },
    6: { name: 'Record Digits', value: 6, code: 'RecordDigits' },
    7: { name: 'Transfer', value: 7, code: 'Transfer' },
    8: { name: 'Hangup', value: 5, code: 'Hangup' },
    9: { name: 'Return', value: 5, code: 'Return' },
    10: { name: 'Begin', value: 5, code: 'Begin' },
    11: { name: 'Repeat', value: 5, code: 'Repeat' },
    12: { name: 'ASR', value: 12, code: 'ASRStep' },
    13: { name: 'Delay', value: 13, code: 'Delay' }
  }
};

var TRANSITIONS = {
  DIGITS: 1,
  NEXT: 2,
  ASR: 3,
  VARCOMP: 4,
  properties: {
    1: { name: 'Digits', value: 1, code: 'Digits' },
    2: { name: 'Next', value: 2, code: 'Next' },
    3: { name: 'ASR', value: 3, code: 'ASR' },
    4: { name: 'VarComp', value: 4, code: 'VarComp' }
  }
};

var WAIT_TIME_LIMIT = 90;
var RETRY_TIME_LIMIT = 300;

function createAxiosInstance() {
  var instance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({ timeout: 30000, headers: { common: [] } });
  delete instance.defaults.headers.common['Authorization'];
  __WEBPACK_IMPORTED_MODULE_2_axios_retry___default()(instance, { retries: 5,
    retryDelay: function retryDelay(count) {
      return Math.pow(2, count) * 500;
    },

    retryCondition: __WEBPACK_IMPORTED_MODULE_2_axios_retry__["isSafeRequestError"]
  });
  return instance;
}

var getConfig = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var instance, _ref2, conf;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (true) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', {
              wsBaseURL: wsBaseURL,
              backendBaseURL: backendBaseURL,
              softwareTitle: 'IPCOM VORTEX !!! DEV VERSION !!!'
            });

          case 2:
            instance = createAxiosInstance();
            _context.next = 5;
            return instance.get('/conf');

          case 5:
            _ref2 = _context.sent;
            conf = _ref2.data;
            return _context.abrupt('return', {
              wsBaseURL: conf.ws,
              backendBaseURL: conf.api,
              softwareTitle: conf.softwareTitle
            });

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getConfig() {
    return _ref.apply(this, arguments);
  };
}();

var getLogo = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (true) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt('return', '/static/img/logo.svg');

          case 2:
            return _context2.abrupt('return', '/logo');

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getLogo() {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_i18n__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_js__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es_js__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pt_js__ = __webpack_require__(572);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('es', __WEBPACK_IMPORTED_MODULE_4__es_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('en', __WEBPACK_IMPORTED_MODULE_3__en_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.add('pt', __WEBPACK_IMPORTED_MODULE_5__pt_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.set('es');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n.fallback('en');

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].i18n);

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  es: {
    messages: {
      alpha: function alpha(input) {
        return 'El campo de ' + input + ' sólo puede contener caracteres alfabéticos';
      },
      alpha_num: function alpha_num(input) {
        return 'El campo de ' + input + ' sólo puede contener caracteres alfanuméricos.';
      },
      required: function required(input) {
        return 'El campo de ' + input + ' es requerido';
      },
      min: function min(input) {
        return 'El campo de ' + input + ' debe tener al menos 5 caracteres.';
      },
      alpha_spaces: function alpha_spaces(input) {
        return 'El campo de ' + input + ' sólo puede contener caracteres alfabéticos, así como espacios.';
      },
      email: function email(input) {
        return 'El campo de correo no es válido.';
      },
      numeric: function numeric(input) {
        return 'El campo de ' + input + ' no es válido.';
      },
      confirmed: function confirmed(input) {
        return 'El campo ' + input + ' no coindice con la clave.';
      },
      max_value: function max_value(input, value) {
        return 'El campo ' + input + ' debe ser ' + value + ' o menos.';
      }
    }
  }
});

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 477:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(100)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1018),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var Component = __webpack_require__(100)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1015),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b2b1e46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Orgs */
/* unused harmony export Campaigns */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Files; });
/* unused harmony export Voice */
/* unused harmony export Peers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Headers; });
/* unused harmony export SubscriberDb */
/* unused harmony export Audio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CampaignStatus; });
/* unused harmony export Variables */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResetLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Roles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_feathers_client__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_feathers_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_feathers_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_feathers_hooks__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_feathers_hooks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_feathers_hooks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_feathers_rest_client__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_feathers_rest_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_feathers_rest_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_feathers_authentication_client__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_feathers_authentication_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_feathers_authentication_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(13);

// import io from 'socket.io-client'



// import socketio from 'feathers-socketio/client'

// import localstorage from 'feathers-localstorage'



var host = __WEBPACK_IMPORTED_MODULE_6_vue__["default"].$backendBaseURL;

var app = __WEBPACK_IMPORTED_MODULE_1_feathers_client___default()()
// .configure(socketio(socket))
.configure(__WEBPACK_IMPORTED_MODULE_4_feathers_rest_client___default()(host).axios(__WEBPACK_IMPORTED_MODULE_2_axios___default.a)).configure(__WEBPACK_IMPORTED_MODULE_3_feathers_hooks___default()()).configure(__WEBPACK_IMPORTED_MODULE_5_feathers_authentication_client___default()({ storage: window.localStorage, path: '/authenticate' }));

// socket.on('reconnect', () => { app.authenticate() })

/* harmony default export */ __webpack_exports__["e"] = (app);

var Orgs = app.service('orgs');
var Campaigns = app.service('orgs/:orgId/campaigns');
var Files = app.service('orgs/:orgId/files');
var Voice = app.service('voices');
var Peers = app.service('peers');
var Headers = app.service('orgs/:orgId/files/:fileId/headers');
var SubscriberDb = app.service('orgs/:orgId/subscriber_db');
var Audio = app.service('orgs/:orgId/files/:fileId');
var CampaignStatus = app.service('orgs/:orgId/campaigns/:campaignId/status');
var Variables = app.service('orgs/:orgId/subscriber_db/:subscriberDbId/variables');
var ResetLink = app.service('users/:userId/resetlink');
var Roles = app.service('roles');
var Users = app.service('orgs/:orgId/users');

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","type":"object","description":"the dialplan object. If a step that does not have input or step property set is reached. Call will be hanged up.","properties":{"initialStep":{"$ref":"#/definitions/DialPlanStep"}},"required":["initialStep"],"additionalProperties":false,"definitions":{"DialPlanStep":{"type":"object","oneOf":[{"$ref":"#/definitions/DialPlanStepTTS"},{"$ref":"#/definitions/DialPlanStepPlayback"},{"$ref":"#/definitions/DialPlanStepWebVariable"},{"$ref":"#/definitions/DialPlanStepRecord"},{"$ref":"#/definitions/DialPlanStepDelay"},{"$ref":"#/definitions/DialPlanStepRecordDigits"},{"$ref":"#/definitions/DialPlanStepTransfer"},{"$ref":"#/definitions/DialPlanStepASR"},{"$ref":"#/definitions/DialPlanStepSimpleAction"}]},"DialPlanInput":{"type":"object","oneOf":[{"$ref":"#/definitions/DialPlanInputDigits"},{"$ref":"#/definitions/DialPlanInputASR"},{"$ref":"#/definitions/DialPlanVarComp"}]},"Voice2":{"type":"object","properties":{"provider":{"type":"string"},"voiceCode":{"type":"string"}},"required":["provider","voiceCode"]},"DialPlanStepTTS":{"type":"object","properties":{"type":{"const":"TTS"},"text":{"description":"Text to be generated by the TTS system. Variables are interpolated by using braces. e.g.: Hello {name}","type":"string"},"preaudio":{"description":"fileId of audio to play just before the generated TTS audio","type":"string"},"postaudio":{"type":"string","description":"fileId of audio to play after the generated TTS audio has been played"},"voice2":{"$ref":"#/definitions/Voice2"},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"}},"required":["type","text","voice2"]},"DialPlanStepPlayback":{"type":"object","properties":{"type":{"const":"Playback"},"audio":{"type":"string","description":"The fileId of the  audio to be played."},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"}},"required":["type","audio"]},"DialPlanStepWebVariable":{"type":"object","description":"This step calls a URL and then reads out with a TTS the result. The result must be text/plain mime type utf-8 encoded.","properties":{"type":{"const":"WebVariable"},"url":{"type":"string"},"varname":{"type":"string","description":"the name of the variable where the result would be stored","minLength":1},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"}},"required":["type","url","varname"]},"DialPlanStepRecord":{"type":"object","description":"a step to record a user voice into a file.","properties":{"type":{"const":"Record"},"preAudio":{"type":"string","description":"The fileId of the  audio to be played before start recording."},"prefix":{"type":"string","description":"the prefix for the file generated by the recording."},"maxLength":{"description":"max length in second of the audio","type":"integer","default":10},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"}},"required":["type","preAudio"]},"DialPlanStepRecordDigits":{"description":"A step that record digits to a variable. Can do confirmation with TTS,\npre recorded audio + default digits or no confirmation at all. ","type":"object","properties":{"type":{"const":"RecordDigits"},"varname":{"type":"string","description":"the name of the variable where the result would be stored"},"endPound":{"type":"boolean","description":"if true would end sequence when '#' is pressed"},"preAudio":{"type":"string","description":"fileId of the audio before expecting the digits."},"digitTimeout":{"type":"integer","description":"the timeout after the last digit is pressed","default":5},"repeatPreAudio":{"type":"string","description":"the fileId for the audio to ask the user to verify. Must be in the form of \"You entered \""},"repeatPostAudio":{"type":"string","description":"the fileId for the audio to ask the user to verify. Must be in the form of \"press 1 if it is correct, 2 to try again\""},"digitsVoice":{"type":"string","description":"one of the existing system voices to repeat digits."},"text":{"type":"string","description":"TTS text to say digits. Must be something like: \"You entered {sysdig}. Please press 1 if it is correct, 2 to try again.\". If this property is set then repeatPostAudio, repeatPreAudio, and digitsVoice will be ignored."},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"}},"required":["type","varname"]},"DialPlanStepTransfer":{"description":"A step to transfer to an outside peer.","type":"object","properties":{"type":{"const":"Transfer"},"extension":{"type":"string"},"preaudio":{"type":"string"},"hangupIfNoAnswer":{"type":"boolean","description":"if true, if no ones answers hangup. if false it will return to the begging of the dialplan.  default is false.","default":false},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"}},"required":["type","extension"]},"DialPlanStepSimpleAction":{"type":"object","description":"Performs a simple unconditional action.\n","properties":{"type":{"const":"SimpleAction"},"action":{"description":"The action to perform. Can have the following values:\n* hangup: unconditionally hangs up the call.\n* return: returns to previous step \n* begin: returns to the first step","type":"string","enum":["hangup","return","begin","repeat"]},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"}},"required":["type","action"]},"DialPlanStepDelay":{"type":"object","properties":{"type":{"const":"Delay"},"delay":{"type":"integer","description":"Number of seconds to delay"},"input":{"description":"any of the objects describing an input (DialPlanInputDigits, DialPlannInputASR)","type":"object"},"step":{"$ref":"#/definitions/DialPlanStep"},"note":{"type":"string","description":"user annotation"},"title":{"type":"string","description":"user title"}},"required":["type"]},"DialPlanStepASR":{"type":"object","description":"A step to input ASR, can wait for a timeout. ","properties":{"type":{"const":"ASRStep"},"timeout":{"type":"integer","description":"timeout in seconds","default":5},"tts":{"type":"string"},"voice":{"type":"string"},"voice2":{"$ref":"#/definitions/Voice2"},"language":{"description":"The language in BCP47 format","type":"string","example":"en-US","default":"es-CO"},"title":{"type":"string","description":"user title"},"varname":{"type":"string"},"input":{"$ref":"#/definitions/DialPlanInput"},"step":{"$ref":"#/definitions/DialPlanStep"}},"required":["varname"]},"DialPlanInputDigits":{"type":"object","description":"A step to input one digit, can wait for a timeout. ","properties":{"type":{"const":"Digits"},"digitTimeout":{"type":"integer","description":"timeout for digitInputs in seconds","default":5},"varname":{"type":"string","description":"the name of the variable where the result would be stored","minLength":1},"choices":{"description":"choices of digits.","type":"array","items":{"$ref":"#/definitions/DigitInput"}}},"required":["varname","type","choices"]},"DigitInput":{"type":"object","properties":{"digits":{"type":"string"},"step":{"$ref":"#/definitions/DialPlanStep"}},"required":["digits","step"]},"DialPlanInputASR":{"type":"object","description":"A step to input via ASR, can wait for a timeout. ","properties":{"type":{"const":"ASR"},"silence":{"type":"integer","description":"wait for this silence to end recording","default":3},"varname":{"type":"string","description":"the name of the variable where the result would be stored","minLength":1},"invalidAudio":{"type":"string","description":"fileId of  audio saying choice is wrong or did not understand"},"repeatTimes":{"type":"integer","description":"number of times allowed to repeat if not understood","default":1},"language":{"type":"string","description":"language selected","default":"es-MX"},"choices":{"description":"choices of phrase","type":"array","items":{"$ref":"#/definitions/ASRInput"}}},"required":["varname","type","choices"]},"ASRInput":{"type":"object","properties":{"phrases":{"type":"string","description":"comma separated phrases to be detected by the ASR"},"step":{"type":"object","$ref":"#/definitions/DialPlanStep"}}},"DialPlanVarComp":{"type":"object","description":"A transition using boolean expression, can wait for a timeout. ","properties":{"type":{"const":"VarComp"},"varname":{"type":"string","description":"the name of the variable where the result would be stored"},"choices":{"description":"matching choices","type":"array","items":{"$ref":"#/definitions/VarCompChoice"}},"defaultChoice":{"description":"the default choice when all other choices do not match","type":"object"}},"required":["varname","type","choices"]},"VarCompChoice":{"type":"object","properties":{"name":{"type":"string"},"hint":{"type":"array","items":{"type":"string"}},"expression":{"type":"string","description":"the boolean expression for comparison"},"compType":{"type":"string","enum":["text","number"]},"step":{"$ref":"#/definitions/DialPlanStep"}},"required":["name","expression"]}}}

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.2","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  global: {
    '~NOMBRE_SISTEMA~': 'IPCOM VORTEX',
    '~ESPANOL~': 'Spanish',
    '~PORTUGUES~': 'Portuguese',
    '~INGLES~': 'English',
    '~ITALIANO~': 'Italian',
    '~FRANCES~': 'French',
    '~IDIOMA~': 'Language',
    '~IDIOMA2~': 'Recognition Language',
    '~MENU~': 'Menu',
    '~USUARIOS~': 'Users',
    '~EDITAR~': 'Edit',
    '~DUPLICAR~': 'Duplicate',
    '~REFRESCAR~': 'Refresh',
    '~DESACTIVAR~': 'Deactivate',
    '~CARGANDO~': 'Loading',
    '~TOTALES~': 'totals',
    '~ACTIVAR~': 'Activate',
    '~AYUDA~': 'Help',
    '~AYUDA_ACTIVADA~': 'Help Active',
    '~AYUDA_DESACTIVADA~': 'Help Disabled',
    '~ACTIVADAS~': 'Help messages activated',
    '~DESACTIVADAS~': 'Help messages deactivated',
    '~CONFIRMAR_AYUDA~': 'Do you want to deactivate help messages?',
    '~ACEPTAR~': 'Accept',
    '~CONECTANDO~': 'Connecting',
    '~OPCIONES~': 'Options',
    '~ELIMINAR~': 'Delete',
    '~REMOVER~': 'Remove',
    '~CANCELAR~': 'Cancel',
    '~OMITIR~': 'Skip',
    '~EXPANDIR~': 'Expand',
    '~AGREGAR~': 'Add',
    '~AVATAR~': 'Avatar',
    '~CONFIGURACION~': 'Configuration',
    '~HOY~': 'Today',
    '~SEMANA~': 'Week',
    '~PERSONALIZAR~': 'Personalize',
    '~ESTUDIANTE~': 'Estudent',
    '~MASCULINO~': 'Male',
    '~FEMENINO~': 'Female',
    '~VOLVER~': 'Back',
    '~SIGUIENTE~': 'Next',
    '~ANTERIOR~': 'Previous',
    '~GUARDAR~': 'Save',
    '~CERRAR~': 'Close',
    '~VALIDA_POR~': 'Valid for',
    '~FAMILIA~': 'Families',
    '~AUTORIZADO~': 'Authorized',
    '~AMIGOS~': 'Friends',
    '~PERSONAS~': 'People',
    '~TOKEN~': 'Token',
    '~TOKENS~': 'Tokens',
    '~VEHICULOS~': 'Vehicles',
    '~RETIRADAS_AUTORIZADO~': 'Withdrawals for Authorized',
    '~HORAS_RETIRADA~': 'Withdrawal Hours',
    '~CAMBIAR_CLAVE~': 'Change Password',
    '~EDITAR_PERFIL~': 'Edit Profile',
    '~HOME~': 'Home',
    '~COFIGURACION~': 'Configuration',
    '~MENU_PRINCIPAL~': 'Main Menu',
    '~FECHA~': 'Date',
    '~ALUMNOS~': 'Students',
    '~INFORMACION~': 'Information',
    '~FOTO_PERFIL~': 'Profile Picture',
    '~FOTO_VEHICULO~': 'Vehicle Picture',
    '~TOMAR_FOTO~': 'Take Photo',
    '~SUBIR_ARCHIVO~': 'Upload File',
    '~REGISTROS~': 'Register',
    '~ZOOM~': 'Zoom',
    '~DETALLES~': 'Details',
    '~BUSCADOR~': 'Search',
    '~SALIR~': 'Logout',
    '~TIPO~': 'Type',
    '~CONTINUAR~': 'Continue',
    '~CONFIRMAR~': 'Confirm',
    '~FINALIZAR~': 'Finalize',
    '~FINALIZADO~': 'The campaign is save',
    '~ALERTA~': 'Warning!',
    '~TITULO~': 'Title',
    '~VOZ~': 'Voice',
    '~NOTA~': 'Note',
    '~ACCION~': 'Action',
    '~ACCIONES~': 'Actions',
    '~FILAS~': 'Rows',
    '~DE~': 'of',
    '~A~': 'to',
    '~TEXTO~': 'Text',
    '~NUMERO~': 'Number',
    '~NEXT_STEP~': 'Next step',
    '~CONFIRMAR_BORRAR~': 'Are you sure you want to delete?',
    '~CONFIRMAR_REMOVER~': 'Are you sure you want to remove?',
    '~CONFIRMAR_PARAR~': 'Are you sure you want to stop the campaign?',
    '~MENSAJE_REFRESCAR~': 'Warning! The information in this table is not up to date, <br> please click on \'Refresh\'',
    relation: {
      '~NOMBRE~': 'Relation',
      options: {
        '~PADRE~': 'Parent',
        '~HIJO~': 'Child',
        '~RELATIVO~': 'Relative',
        '~EMPLEADO~': 'Employee'
      }
    }
  },
  message: {
    '~CORREO_TOMADO~': 'The email has been taken'
  },
  login: {
    '~TITULO~': 'Authentication',
    '~USUARIO~': 'User',
    '~CLAVE~': 'Password',
    '~NUEVA~': 'New Password',
    '~CORREO~': 'Email',
    '~ENTRAR~': 'Enter',
    '~OLVIDO~': 'Forgot your password?',
    '~RECORDARME~': 'Remember me',
    '~CONTACTO~': 'Contact Webmaster',
    '~RECUPERAR~': 'Password Recovery',
    '~MENSAJE~': 'We have sent an email with the recovery instructions',
    '~RECUPERACION_OK~': 'Your password has been successfully modified',
    '~ENVIAR~': 'Send',
    '~VOLVER~': 'Back to Login',
    '~RESETEAR~': 'Reset Password',
    '~VERIFICAR~': 'Validate Password',
    '~BIENVENIDO~': 'Wellcome to IP-COM System',
    '~NO_AUTORIZADO~': 'Error! email or password incorrect',
    '~NO_AUTENTICADO~': 'Sorry! You are not authenticated',
    '~EXITOSO~': 'Login Success',
    '~NO_USUARIO~': 'Error! This user is not found'
  },
  menu: {
    '~INICIO~': 'Home',
    '~TABLERO~': 'Dashboard',
    '~CAMPAGNA~': 'Campaigns',
    '~CAMPAGNA_ABIERTA~': 'Open Campaigns',
    '~BASE_DATOS~': 'Databases',
    '~ORGANIZACION~': 'Organizations',
    '~USUARIOS~': 'Users',
    '~REPORTES~': 'Reports',
    '~CONFIGURACION~': 'Settings'
  },
  campaign: {
    '~CAMPAGNA~': 'Campaign',
    '~IDIOMA~': 'Language',
    '~CAMPAGNA_ABIERTA~': 'Open Campaign Mode',
    '~EDITAR~': 'Edit Campaign',
    '~CERRAR~': 'Close Campaign',
    '~INSERTAR~': 'New Campaign',
    '~NOMBRE~': 'Campaign Name',
    '~SUSCRIPTORES~': 'Suscriber BD',
    '~PASO~': 'Step',
    '~ESTADO~': 'Status',
    '~ARBOL~': 'Navigation Tree',
    '~TRANSICION~': 'Transition',
    '~DIGITOS~': 'Digits',
    '~VARIABLE_NOMBRE~': 'Variable Name',
    '~TIEMPO~': 'Timeout',
    '~COMANDO_VOZ~': 'Voice',
    '~BASE_DATOS~': 'Database',
    '~LLAMADAS~': 'Concurrent Calls',
    '~INTERACCION~': 'Interactions',
    '~TASA_CONTACTO~': 'Contact Rate',
    '~PREFIJO~': 'Dial Prefix',
    '~REJECT_CODES~': 'ISDN Reject Codes',
    '~GRUPOS_RUTAS~': 'Route Group',
    '~IDENTIFICADOR~': 'Caller ID',
    '~ID_CLIENTE~': 'Client ID',
    '~TIEMPO_ESPERA~': 'Wait Time',
    '~TIEMPO_DIGITOS~': 'Digits Timeout',
    '~TIEMPO_REINTENTO~': 'Retry Time',
    '~MAQUINA_RESPUESTA~': 'Answer machine detection',
    '~MAQUINA_RESPUESTA_TOOLTIP~': 'Automatically detects answering machines (AMD) and voicemail.',
    '~MAQUINA_COLGAR~': 'Answer Machine Detection Hangup',
    '~MAQUINA_COLGAR_TOOLTIP~': 'Ends the call when voicemail is detected.',
    '~TITULO~': 'Title',
    '~TODAS~': 'All',
    '~TTS_MENSAJE~': 'TTS Message',
    '~TTS_MENSAJE2~': 'Previous TTS Message',
    '~PREFIJO_ARCHIVO~': 'File Prefix',
    '~MAXIMA_LONGITUD~': 'Max Length',
    '~REPETIR~': 'Repeat',
    '~FINAL~': '# At the end',
    '~IMPORTAR~': 'Import Contacts',
    '~IMPORTAR_CVS~': 'Import new records',
    '~IMPORTAR_DESC~': 'Now let\'s match the columns in your uploaded file to your Subscriber DB List',
    '~OMITIR_CABECERAS~': 'No Headers',
    '~NUEVA_COLUMNA~': 'New Column Name',
    '~INTENTOS_MAXIMOS~': 'Max Attempts',
    '~PROXIMO_REINTENTO~': 'NRA',
    '~INTENTOS_ALCANZADOS~': 'Maximum number of attempts reached',
    '~LLAMADAS_ALCANZADOS~': 'Maximum number of calls reached',
    '~INTENTOS_MAX~': 'Max Attempts',
    '~MAXIMO_ALCANZADO~': 'Maximum limit reached',
    '~CANALES_MAXIMOS~': 'Max Channels',
    '~ZONA_HORARIA~': 'Time Zone',
    '~COLGAR_NO_RESP~': 'Hang up if no answer',
    '~EXTENSION~': 'Extension',
    '~MINIMO_HORA~': 'Minimum Hour',
    '~MAXIMO_HORA~': 'Maximum Hour',
    '~SELECCIONAR_FECHA~': 'Select Date',
    '~FECHA_COMIENZO~': 'Start Date',
    '~FECHA_FINAL~': 'End Date',
    '~FECHA_ERROR~': 'Start date must be less than end date.',
    '~FECHA_CREACION~': 'Creation Date',
    '~ACTIVAS~': 'Active Campaigns',
    '~ULTIMAS~': 'Last Campaigns',
    '~BASES_MONITOREADAS~': 'Monitoried Bases',
    '~NUMEROS~': 'Numbers',
    '~EN_COLA~': 'Queued',
    '~MARCADO~': 'Dialed',
    '~CONTACTO~': 'Contact',
    '~VER~': 'View',
    '~ACTIVA~': 'Active / Max',
    '~SILENCIO~': 'Silence',
    '~REPETICIONES~': 'Number of Repetitions',
    '~AUDIO_INVALIDO~': 'Retry Audio',
    '~FRASE~': 'Phrase',
    '~VARIABLE~': 'Variable',
    '~FORMULA~': 'Formula',
    '~GENERACION_TTS~': 'TTS Generation',
    '~GENERAR_AUDIOS~': 'Synthetize Audios',
    '~PROBAR_AUDIO~': 'TTS Test',
    '~DESCARGAR_TTS~': 'Dowload TTS',
    '~ARCHIVAR~': 'Archive',
    '~OPERADOR~': 'Operator',
    '~AYUDA_VARCOMP~': 'Advanced code syntax',
    '~GUARDANDO~': 'Saving campaign',
    '~VOICES2_NOT_FOUND~': 'There are no voices for the selected language.',
    '~ACTIVE_CHANNELS~': 'Active Channels',
    subscriber: {
      '~BD_CREADA~': 'The database was created successfuly'
    },
    sayas: {
      '~NOMBRE~': 'Say as',
      options: {
        '~CARACTERES~': 'Characters',
        '~NUMERO~': 'Number',
        '~CARDINAL~': 'Cardinal',
        '~ORDINAL~': 'Ordinal',
        '~DIGITOS~': 'Digits',
        '~FECHA~': 'Date'
      }
    },
    callerId: {
      '~IDENTIFICADOR~': 'Caller ID',
      '~TELEFONO~': 'Phone number as Caller ID',
      '~CLIENTE~': 'Client ID as Caller ID',
      '~SUSCRIPTOR~': 'Subscriber ID as Caller ID'
    },
    '~NO_PAREJA~': 'unmatched column',
    '~NO_CAMPANA~': 'There are no campaigns registered',
    '~NO_ACTIVAS~': 'There are no active campaigns',
    '~SIN_RESULTADOS~': 'No campaigns found matching that criteria',
    '~BUSCAR_CAMPANA~': 'Search by name or ID...',
    '~NO_RESULTADO~': 'There was no search result',
    formula: {
      '~IGUAL~': 'Equal',
      '~MAYOR~': 'Greater than',
      '~MENOR~': 'Less than',
      '~MAYOR_IGUAL~': 'Greater or equal',
      '~MENOR_IGUAL~': 'Less than or equal',
      '~DISTINTO~': 'Distinct',
      '~REGULAR~': 'Regex',
      '~DEFAULT~': 'Default',
      '~DEFAULT_NAME~': 'Default Action'
    }
  },
  organization: {
    '~TITULO~': 'Organization',
    '~TITULO_PROGRAMA~': 'Software Title',
    '~LOGO_PERSONALIZADO~': 'Custom Logo',
    '~EDITAR~': 'Edit Organization',
    '~INSERTAR~': 'New Organization',
    '~NOMBRE~': 'Organization Name',
    '~TELEFONO~': 'Phone',
    '~NOMBRE_COMPLETO~': 'Fullname',
    '~SELECCIONADO~': 'Selected',
    '~NO_ORGANIZATION~': 'There are no organizations registered',
    '~IMAGEN_ERROR~': 'The size limit has been exceeded!',
    '~IMAGEN_MENSAJE~': 'Only .png and .jpg formats, and a maximum size of 5Mg',
    '~IMAGEN_TAMANO~': 'Sizes 264px/120px',
    '~PAÍS~': 'Country',
    '~CPS_MÁXIMO~': 'Maximum CPS',
    '~PROPIA~': 'Own',
    '~TELEFONÍA~': 'Telephony',
    '~Añadir_CPS~': 'Add CPS',
    '~CPS_MÁXIMO_ERROR~': 'The countrys CPS cannot exceed the parent organizations CPS in that country'
  },
  dialer: {
    '~NOMBRE~': 'Dialers',
    '~CAPACIDAD~': 'Capacity',
    '~ACTIVOS~': 'Actives',
    '~NO_MARCADORES~': 'There are no active dialer'
  },
  database: {
    '~TITULO~': 'Database',
    '~EDITAR~': 'Edit Database',
    '~INSERTAR~': 'New Database',
    '~NOMBRE~': 'Database Name',
    '~CREADA~': 'Created',
    '~ESTADO~': 'Status',
    '~COLUMNAS~': 'Columns',
    '~REGISTROS_DE~': 'records of',
    '~SUSCRIPTORES~': 'Subs.',
    '~BORRAR_SUBS~': 'Delete subscribers that are not in this new file',
    '~EDITAR_SUBS~': 'Update variables in existing subscribers',
    '~SUSCRIPTORES_FULL~': 'Subscribers',
    '~NO_DATABASE~': 'There are no databases registered',
    '~NO_RESULTADO~': 'No search result was obtained',
    '~VARIABLE_PHONE~': 'There must be a field with name "phone" to continue',
    '~VALIDATE_NUMBER~': 'Validate numbering',
    '~COUNTRY~': 'Country',
    '~ONLY_CALL_TO_NUMBERS~': 'Dial for numbers only',
    '~DONWLOAD_INVALID_NUMBERS~': 'Do you want to download the report of invalid numbers from the database?'
  },
  report: {
    '~TITULO~': 'Reports',
    '~EDITAR~': 'Edit Report',
    '~INSERTAR~': 'New Report',
    '~CREADA~': 'Created',
    '~ESTADO~': 'Status',
    '~INFORME_RESUMIDO~': 'Summary Report',
    '~INFORME_BASE~': 'Base Summary',
    '~INFORME_DURACION~': 'Summary Duration',
    '~ENCUESTA~': 'Survey',
    '~CONTESTADA~': 'Answered',
    '~RESPUESTAS~': 'Answers',
    '~PROMEDIO_ENCUESTA~': 'Survey Ratio',
    '~OCUPADO~': 'Busy',
    '~SEGUNDOS~': 'Seconds',
    '~SEGUNDOS_MIN~': 'Sec',
    '~MINUTOS~': 'Minutes',
    '~MINUTOS_MIN~': 'Min',
    '~NUMERO_INVALIDO~': 'Invalid Number',
    '~NO_REPICO~': 'No Ring',
    '~NO_CONTESTO~': 'No Answer',
    '~PROMEDIO_CONTESTO~': 'Contact Ratio',
    '~DETALLES_INTENTOS~': 'Details by Attemps',
    '~INTENTOS~': 'Attemps',
    '~DISPOSICION~': 'Disposition',
    '~NUMEROS~': 'Numbers',
    '~CODIGO_ISDN~': 'ISDN Code',
    '~PRIMERO~': 'Firts',
    '~ULTIMO~': 'Last',
    '~NO_REPORTE~': 'There are no report registered',
    '~NO_DATA~': 'You have not enough data',
    '~DESCARGAR~': 'Download Report',

    '~SUMAR_REPORTES~': 'Add Reports',
    '~REPORTE_COMPLETO~': 'Full Report',
    '~SUMADAS~': 'Added',
    '~TITULO_SELECCION~': 'Select the campaigns you want to add to the report'
  },
  users: {
    '~EDITAR~': 'Edit User',
    '~INSERTAR~': 'New User',
    '~NO_USUARIOS~': 'There are no users registered',
    '~AGREGAR~': 'Add User',
    '~TITULO~': 'User List',
    '~NOMBRE~': 'Firstname',
    '~APELLIDO~': 'Lastname',
    '~CORREO~': 'Email',
    '~CLAVE~': 'Password',
    '~TELEFONO~': 'Phone',
    '~CELULAR~': 'Mobile',
    '~POSICION~': 'Position',
    '~ID_TARJETA~': 'Card',
    '~ACTIVO~': 'Active',
    '~INACTIVO~': 'Inactive',
    '~ROL~': 'Roles',
    '~ORGANIZACIONES~': 'Organizations',
    '~ROLES_TODAS~': 'Update roles in all orgs',
    '~ROLES_ACTUAL~': 'Update roles only for',
    '~ACTUALIZAR_ORGS~': 'Actualizar organizaciones a la cual pertenece el usuario',
    '~BUSCAR~': 'Search...',
    '~ETIQUETA_SELECCION~': 'Press enter to select'
  },
  file: {
    '~NOMBRE~': 'Name',
    '~NOMBRE_AMIGABLE~': 'Friendly Name',
    '~SUBIR~': 'Upload File',
    '~ACEPTABLE~': 'Aceptable file type: CSV',
    '~PERMANENTE~': 'Permanent',
    '~DESCARGAR~': 'Download Report'
  },
  audio: {
    '~AGREGAR~': 'Insert Audio',
    '~BORRAR~': 'Delete',
    '~SELECCION~': 'Select Audio',
    '~REPRODUCIR~': 'Play',
    '~REPRODUCIENDO~': 'Playing',
    '~DETENER~': 'Pause',
    '~PAUSAR~': 'Pause',
    '~CONTINUAR~': 'Resume',
    '~VOZ~': 'Voice',
    '~NOMBRE~': 'Audio Name',
    '~ARCHIVO~': 'Audio File',
    '~NO_AUDIO~': 'There were no results',
    '~GUARDANDO~': 'Saving audios'
  },
  action: {
    '~NOMBRE~': 'Action',
    options: {
      '~COLGAR~': 'Hangup',
      '~RETORNAR~': 'Return',
      '~EMPEZAR~': 'Begin',
      '~REPETIR~': 'Repeat'
    }
  },
  step: {
    '~NOMBRE~': 'Step',
    '~GUARDAR~': 'Save Step',
    options: {
      '~TTS~': 'TTS',
      '~PLAYBACK~': 'Playback',
      '~RECORD~': 'Record',
      '~RECORD_DIGITS~': 'Record Digits',
      '~TRANSFERIR~': 'Transfer',
      '~ASR~': 'Asr',
      '~VARIABLE_WEB~': 'Web Variable',
      '~COLGAR~': 'Hangup',
      '~RETORNAR~': 'Return',
      '~EMPEZAR~': 'Begin',
      '~REPETIR~': 'Repeat',
      '~DELAY~': 'Delay'
    }
  },
  transition: {
    '~NOMBRE~': 'Transition',
    options: {
      '~DIGITOS~': 'Digits',
      '~SIGUIENTE~': 'Next',
      '~ASR~': 'ASR',
      '~VARCOMP~': 'Varcomp',
      '~NINGUNO~': 'None'
    }
  },
  tour: {
    admin: {
      '~NAVEGACION~': '<strong>Wellcome to IP-COM System</strong><br /><br />This is de Admin area please take your time for this short tour. <br /><br />With this virtual tour by clicking on. <strong>Next</strong>',
      '~MENU~': 'In this sidebar you will find the main navigation menu, necessary to access any area of the application.',
      '~USER_CARD~': 'User profile information',
      '~SALIR~': 'Logout button.',
      '~LISTA_ORG~': 'Organization selector list, use it to swich the current organization.',
      '~MENU_TABLERO~': '<strong>Dashboard</strong><br /><br />Displays the active campaigns in real time, the last campaigns processed, the affiliate database, and the TTS audios generated in each campaign.',
      '~MENU_ORGANIZACION~': '<strong> Organization </ strong> <br /> <br /> Shows client organizations and allows you to register new organizations, edit them and delete them.',
      '~MENU_BASEDATOS~': '<strong> Databases </ strong> <br /> <br /> View, manage and generate subscriber databases used when creating a campaign.',
      '~MENU_CAMPANA~': '<strong> Campaigns </ strong> <br /> <br /> It allows to see, create, manage and configure campaigns. Monitors the exact time and date of generation of each campaign. Review and download reports.',
      '~MENU_USERS~': '<strong> Users </ strong> <br /> <br /> Registered and authorized users to create, monitor, edit and configure campaigns, databases, etc., according to the role and level of access granted.',
      '~BARRA~': 'Top bar, contains the current navigation page and some tools.',
      '~IDIOMA~': 'Language selection.',
      '~MENU_IDIOMA~': 'Language Options.',
      '~AYUDA~': 'Activate or Deactivate visual aids.',
      '~ACTIVAS~': 'In this panel here, active campaigns are reflected in real time.',
      '~CAMPANAS~': 'In this panel here, the last campaigns created or edited are listed.',
      '~SUBSCRIBERS~': 'In this panel here, the latest subscriber databases created or edited are listed',
      '~TTS_AUDIOS~': 'In this panel here, you will find the progress of the audio generation of the campaigns',
      organization: {
        '~INTRO~': 'Overview of the organizations registered in IPCOM with their data configured according to the company; In addition to the options to add new ones and edit or delete existing ones',
        '~BUSCADOR~': 'Write the name of the organization you want to search',
        '~INSERTAR~': 'Registers new organizations in the system.',
        '~TABLA~': 'Each row shows the ID of the organization in the system and the legal name. You can also edit or delete already registered organizations.',
        '~ACCIONES~': 'Actions for the management of the respective organization.',
        '~EDITAR~': 'Edit data of the organization respectively.',
        '~ELIMINAR~': 'Remove organization from the system after confirmation.'
      },
      subscriber: {
        '~INTRO~': 'Select a database already loaded in the system or add new databases for your campaign.<br /><br />You can edit or delete the database that you require, if necessary.',
        '~BUSCADOR~': 'Enter the name of the database you want to search.',
        '~INSERTAR~': 'Load new databases to the system.',
        '~TABLA~': 'Each row reflects the name of the database, creation date, number of subscribers and columns used in the campaign.',
        '~ACCIONES~': 'Actions for the management of the respective databases.',
        '~EDITAR~': 'Edit the configuration of this database.',
        '~ELIMINAR~': 'Delete this database after confirming.',
        uploadform: {
          '~FORMULARIO~': '<strong>File Form</strong><br /><br /> The CSV (comma-separated values) file is used to exchange data in the form of a spreadsheet column. <br /> <br /> Add the name and upload the CSV file that you have saved to your device.',
          '~ARCHIVO~': 'Click to select the CSV file from your device.',
          '~CANCELAR~': 'Cancel and return to the previous screen.',
          '~ENVIAR~': 'Send form and go to the next step.'
        },
        import: {
          '~FORMULARIO~': '<strong>Import Contacts</strong><br /><br /> Before importing the database, configure the names of the variables contained in the previously loaded CSV file.',
          '~GRUPO~': 'Each box represents a column of the CSV file previously loaded.',
          '~COLUMNAS~': 'This box shows the name of the column, part of its content and configuration options to edit or omit the variable.',
          '~EDITAR~': 'Click if you want to change the name of the column.',
          '~OMITIR~': 'Click if you want to Ignore this column from the database.',
          '~CABECERAS~': 'Allows you to discard the first row or header of the CSV file previously loaded.',
          '~CANCELAR~': 'Cancel and go to the previous menu.',
          '~GUARDAR~': 'Save all changes and generate the new Subscriber Database.'
        }
      },
      campaign: {
        '~INTRO~': 'Review, manage and configure old and new campaigns. <br /><br />Monitors the exact time and date of generation of the campaigns. Review and download reports.',
        '~BUSCADOR~': 'Enter the name of the campaign you want to search.',
        '~INSERTAR~': 'Set up a new campaign from scratch.',
        '~TABLA~': 'Each row presents the name of a campaign in the system, its status, date and time of creation and actions for its configuration.',
        '~ACCIONES~': 'Actions for the management of the respective campaign.',
        '~EDITAR~': 'Edit all data and campaign settings.',
        '~COPIAR~': 'Create new campaigns by cloning the content of this campaign.',
        '~REPORTES~': 'Explore data, statistics and relevant campaign information.',
        '~DESCARGAS~': 'Download the campaign report in a CSV file.',
        '~ARCHIVAR~': 'Archive the campaign report.',
        '~CPS_MÁXIMO_ERROR~': 'The value assigned to the CPS exceeds the maximum established within the organization. Maximum CPS: {cps}.',
        steps: {
          '~COFIGURACION~': '<strong>Configuration</strong><br /><br />Write correctly the requested data in each of the configuration registration boxes.<br /><br />This data determines the value of the variables in the campaign to be added.',
          '~BASEDATOS~': 'Select a database already loaded in the system or add new databases for your campaign.<br /><br />You can edit or delete the database that you require, if necessary.',
          '~DIAPLAN~': 'Create the Campaign you want through a system of steps. <br /> <br /> The Dialplan is organized by steps and transitions.',
          '~ENVIAR~': 'Before sending, verify that the data, files, audios and requests made have been correctly loaded.',
          '~NAVEGADOR~': 'Navigate through this bar (breadcrumbs), to find a way to return to the previous step.',
          '~SELECTOR~': 'Select from this list the type of step that allows you to correctly configure the Dialplan.',
          '~ACTUAL~': 'In this area the current step is configured. <br /> <br /> Fill in the data correctly according to the type of step selected for the Dialplan.',
          '~TRANSICION~': 'The transition allows you to connect new steps in the campaign based on the configuration you need.',
          '~ARBOL~': 'It allows you to know the steps used during the configuration each campaign. <br /> <br /> You can select any step you want to edit',
          '~PASO_ACTUAL~': 'The highlighted in blue means the step that is currently being edited.',
          '~PANEL_CONFIG~': 'Summary of the configuration data in step 1.',
          '~PANEL_DATABASE~': 'Information on the subscriber database that will be used in the campaign.',
          '~PANEL_DIALPLAN~': 'Tree of steps showing the previously configured dial plan.',
          '~ENVIAR_FINAL~': 'Click here to Send, once you agree with the information shown here.',
          '~SINTETIZAR~': 'If there are audios that have to be generated within your tagging plan, you must first click here to proceed to generate them.'
        }
      },
      user: {
        '~INTRO~': 'Know the main data of registered users authorized by your organization to manage and configure the system.',
        '~BUSCADOR~': 'Search a user registered in the application by name.',
        '~INSERTAR~': 'Register a new user in the system.',
        '~TABLA~': 'Each row shows the user\'s first and last names, phone number, email, role in the system, card number and activity status.',
        '~ACCIONES~': 'Actions for the management of the respective user.',
        '~ACIVAR~': 'Activate and deactivate user.',
        '~EDITAR~': 'Edit data from the user respectively.',
        '~ELIMINAR~': 'Remove user from the system after confirmation.'
      }
    }
  }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  global: {
    '~NOMBRE_SISTEMA~': 'IPCOM VORTEX',
    '~ESPANOL~': 'Español',
    '~INGLES~': 'Inglés',
    '~PORTUGUES~': 'Portugués',
    '~ITALIANO~': 'Italiano',
    '~FRANCES~': 'Francés',
    '~IDIOMA~': 'Idioma',
    '~IDIOMA2~': 'Idioma de Reconocimiento',
    '~MENU~': 'Menú',
    '~USUARIOS~': 'Usuarios',
    '~EDITAR~': 'Editar',
    '~DUPLICAR~': 'Duplicar',
    '~REFRESCAR~': 'Refrescar',
    '~DESACTIVAR~': 'Desactivar',
    '~CARGANDO~': 'Cargando',
    '~TOTALES~': 'totales',
    '~ACTIVAR~': 'Activar',
    '~AYUDA~': 'Ayuda',
    '~AYUDA_ACTIVADA~': 'Ayudas Activadas',
    '~AYUDA_DESACTIVADA~': 'Ayudas Inactivas',
    '~ACTIVADAS~': 'Mensajes de ayuda activados',
    '~DESACTIVADAS~': 'Mensajes de ayuda desactivados',
    '~CONFIRMAR_AYUDA~': '¿Desea desactivar los mensajes de ayuda?',
    '~ACEPTAR~': 'Aceptar',
    '~CONECTANDO~': 'Conectando',
    '~OPCIONES~': 'Opciones',
    '~ELIMINAR~': 'Eliminar',
    '~REMOVER~': 'Remover',
    '~CANCELAR~': 'Cancelar',
    '~OMITIR~': 'Omitir',
    '~EXPANDIR~': 'Expandir',
    '~AGREGAR~': 'Agregar',
    '~AVATAR~': 'Avatar',
    '~CONFIGURACION~': 'Configuración',
    '~HOY~': 'Hoy',
    '~SEMANA~': 'Semana',
    '~PERSONALIZAR~': 'Personalizar',
    '~ESTUDIANTE~': 'Estudiante',
    '~MASCULINO~': 'Masculino',
    '~FEMENINO~': 'Femenino',
    '~VOLVER~': 'Volver',
    '~SIGUIENTE~': 'Siguiente',
    '~ANTERIOR~': 'Anterior',
    '~GUARDAR~': 'Guardar',
    '~CERRAR~': 'Cerrar',
    '~VALIDA_POR~': 'Válida por',
    '~FAMILIA~': 'Familias',
    '~AUTORIZADO~': 'Autorizado',
    '~AMIGOS~': 'Amigos',
    '~PERSONAS~': 'Personas',
    '~TOKEN~': 'Token',
    '~TOKENS~': 'Tokens',
    '~VEHICULOS~': 'Vehículos',
    '~RETIRADAS_AUTORIZADO~': 'Retiradas por Autorizado',
    '~HORAS_RETIRADA~': 'Horas de Retirada',
    '~CAMBIAR_CLAVE~': 'Cambiar Clave',
    '~EDITAR_PERFIL~': 'Editar Perfil',
    '~HOME~': 'Inicio',
    '~COFIGURACION~': 'Configuración',
    '~MENU_PRINCIPAL~': 'Menú Principal',
    '~FECHA~': 'Fecha',
    '~ALUMNOS~': 'Alumnos',
    '~INFORMACION~': 'Información',
    '~FOTO_PERFIL~': 'Foto de Perfil',
    '~FOTO_VEHICULO~': 'Foto del Vehículo',
    '~TOMAR_FOTO~': 'Tomar Foto',
    '~SUBIR_ARCHIVO~': 'Subir Archivo',
    '~REGISTROS~': 'Registros',
    '~ZOOM~': 'Zoom',
    '~DETALLES~': 'Detalles',
    '~BUSCADOR~': 'Buscar',
    '~SALIR~': 'Salir',
    '~TIPO~': 'Tipo',
    '~CONTINUAR~': 'Continuar',
    '~CONFIRMAR~': 'Confirmar',
    '~FINALIZAR~': 'Finalizar',
    '~FINALIZADO~': 'Campaña guardada',
    '~ALERTA~': '¡Alerta!',
    '~TITULO~': 'Titulo',
    '~VOZ~': 'Voz',
    '~NOTA~': 'Nota',
    '~ACCION~': 'Acción',
    '~ACCIONES~': 'Acciones',
    '~FILAS~': 'Filas',
    '~DE~': 'de',
    '~A~': 'a',
    '~TEXTO~': 'Texto',
    '~NUMERO~': 'Número',
    '~NEXT_STEP~': 'Siguente Paso',
    '~CONFIRMAR_BORRAR~': '¿Está seguro que desea eliminar?',
    '~CONFIRMAR_REMOVER~': '¿Está seguro que desea remover?',
    '~CONFIRMAR_PARAR~': '¿Está seguro que desea detener la campaña?',
    '~MENSAJE_REFRESCAR~': '¡Advertencia! La información en esta tabla no está actualizada, <br /> por favor haga click en \'Refrescar\'',
    relation: {
      '~NOMBRE~': 'Relación',
      options: {
        '~PADRE~': 'Padre',
        '~HIJO~': 'Hijo',
        '~RELATIVO~': 'Familiar',
        '~EMPLEADO~': 'Empleado'
      }
    }
  },
  message: {
    '~CORREO_TOMADO~': 'EL correo electronico ya está tomado'
  },
  login: {
    '~TITULO~': 'Autenticación',
    '~USUARIO~': 'Usuario',
    '~CLAVE~': 'Clave',
    '~NUEVA~': 'Nueva Clave',
    '~CORREO~': 'Correo',
    '~ENTRAR~': 'Entrar',
    '~OLVIDO~': '¿Has olvidado la contraseña?',
    '~RECORDARME~': 'Recordarme',
    '~CONTACTO~': 'Contactar Webmaster',
    '~RECUPERAR~': 'Recuperar Clave',
    '~MENSAJE~': 'Hemos enviado un correo con las instrucciones de recuperación',
    '~RECUPERACION_OK~': 'Su contraseña ha sido modificada exitosamente',
    '~ENVIAR~': 'Enviar',
    '~VOLVER~': 'Volver',
    '~RESETEAR~': 'Resetear Clave',
    '~VERIFICAR~': 'Verificar Clave',
    '~BIENVENIDO~': 'Bienvenido al Sistema IP-COM',
    '~NO_AUTORIZADO~': '¡Disculpe! el correo o la clave son incorrectos',
    '~NO_AUTENTICADO~': '¡Disculpe! Usted no se encuentra autenticado',
    '~EXITOSO~': 'Inicio de sesión exitoso',
    '~NO_USUARIO~': '¡Error! Este usuario no se encuentra'
  },
  menu: {
    '~INICIO~': 'Inicio',
    '~TABLERO~': 'Tablero',
    '~CAMPAGNA~': 'Campañas',
    '~CAMPAGNA_ABIERTA~': 'Campañas Abiertas',
    '~BASE_DATOS~': 'Bases de Datos',
    '~ORGANIZACION~': 'Organizaciones',
    '~USUARIOS~': 'Usuarios',
    '~REPORTES~': 'Reportes',
    '~CONFIGURACION~': 'Configuración'
  },
  campaign: {
    '~CAMPAGNA~': 'Campaña',
    '~IDIOMA~': 'Idioma',
    '~CAMPAGNA_ABIERTA~': 'Modo Campaña Abierta',
    '~EDITAR~': 'Editar Campaña',
    '~CERRAR~': 'Cerrar Campaña',
    '~INSERTAR~': 'Nueva Campaña',
    '~NOMBRE~': 'Nombre de Campaña',
    '~SUSCRIPTORES~': 'BD Suscriptores',
    '~PASO~': 'Paso',
    '~ESTADO~': 'Estado',
    '~ARBOL~': 'Arbol de Navegación',
    '~TRANSICION~': 'Transición',
    '~DIGITOS~': 'Dígitos',
    '~VARIABLE_NOMBRE~': 'Nombre Variable',
    '~TIEMPO~': 'Tiempo',
    '~COMANDO_VOZ~': 'Voz',
    '~BASE_DATOS~': 'Base de Datos',
    '~LLAMADAS~': 'Llamadas Concurrentes',
    '~INTERACCION~': 'Interacción',
    '~TASA_CONTACTO~': 'Tasa de contacto',
    '~PREFIJO~': 'Prefijo de Marcado',
    '~REJECT_CODES~': 'Códigos de Rechazo RDSI',
    '~GRUPOS_RUTAS~': 'Grupos de Rutas',
    '~IDENTIFICADOR~': 'ID de Llamada',
    '~ID_CLIENTE~': 'ID Cliente',
    '~TIEMPO_ESPERA~': 'Tiempo de Espera',
    '~TIEMPO_DIGITOS~': 'Tiempo de Espera de Dígito',
    '~TIEMPO_REINTENTO~': 'Tiempo de Reintento',
    '~MAQUINA_RESPUESTA~': 'Detección de contestador automático',
    '~MAQUINA_RESPUESTA_TOOLTIP~': 'Detecta automáticamente contestadores (AMD) y buzones de voz.',
    '~MAQUINA_COLGAR~': 'Colgar al detectar correo de voz',
    '~MAQUINA_COLGAR_TOOLTIP~': 'Finaliza la llamada cuando detecta un buzón de voz.',
    '~TITULO~': 'Título',
    '~TODAS~': 'Todas',
    '~TTS_MENSAJE~': 'Mensaje TTS',
    '~TTS_MENSAJE2~': 'Mensaje TTS Previo',
    '~PREFIJO_ARCHIVO~': 'Prefijo de Archivo',
    '~MAXIMA_LONGITUD~': 'Máxima Logitud',
    '~REPETIR~': 'Repetir',
    '~FINAL~': '# Al Final',
    '~IMPORTAR~': 'Importar Contactos',
    '~IMPORTAR_CVS~': 'Importar nuevos registros',
    '~IMPORTAR_DESC~': 'Ahora emparejemos las columnas del archivo cargado con su lista de Suscriptores',
    '~OMITIR_CABECERAS~': 'Sin Cabeceras',
    '~NUEVA_COLUMNA~': 'Nombre Nuevo',
    '~INTENTOS_MAXIMOS~': 'Máximo de Intentos',
    '~PROXIMO_REINTENTO~': 'PRI',
    '~INTENTOS_ALCANZADOS~': 'Número máximo de intentos alcanzado',
    '~LLAMADAS_ALCANZADOS~': 'Número máximo de llamadas alcanzado',
    '~INTENTOS_MAX~': 'Máx. Intentos',
    '~MAXIMO_ALCANZADO~': 'Limite máximo alcanzado',
    '~CANALES_MAXIMOS~': 'Canales Máximos',
    '~ZONA_HORARIA~': 'Zona Horaria',
    '~COLGAR_NO_RESP~': 'Colgar si no hay respuesta',
    '~EXTENSION~': 'Extensión',
    '~MINIMO_HORA~': 'Hora Mínima',
    '~MAXIMO_HORA~': 'Hora Máxima',
    '~SELECCIONAR_FECHA~': 'Seleccionar Fecha',
    '~FECHA_COMIENZO~': 'Fecha Inicio',
    '~FECHA_FINAL~': 'Fecha Final',
    '~FECHA_ERROR~': 'La fecha de inicio debe menor que la fecha final.',
    '~FECHA_CREACION~': 'Fecha de Creación',
    '~ACTIVAS~': 'Campañas Activas',
    '~ULTIMAS~': 'Últimas Campañas',
    '~BASES_MONITOREADAS~': 'Bases Monitoreadas',
    '~NUMEROS~': 'Numeros',
    '~EN_COLA~': 'En Cola',
    '~MARCADO~': 'Marcado',
    '~CONTACTO~': 'Contacto',
    '~VER~': 'Ver',
    '~ACTIVA~': 'Activo / Máx',
    '~SILENCIO~': 'Silencio',
    '~REPETICIONES~': 'Número de Repeticiones',
    '~AUDIO_INVALIDO~': 'Audio de Reintento',
    '~FRASE~': 'Frase',
    '~VARIABLE~': 'Variable',
    '~FORMULA~': 'Formula',
    '~GENERACION_TTS~': 'Generación de TTS',
    '~GENERAR_AUDIOS~': 'Sintetizar Audios',
    '~PROBAR_AUDIO~': 'Probar TTS',
    '~DESCARGAR_TTS~': 'Descargar TTS',
    '~ARCHIVAR~': 'Archivar',
    '~OPERADOR~': 'Operador',
    '~AYUDA_VARCOMP~': 'Sintaxis códigos avanzados',
    '~GUARDANDO~': 'Guardando campaña',
    '~VOICES2_NOT_FOUND~': 'No existen voces para el idioma seleccionado.',
    '~ACTIVE_CHANNELS~': 'Canales Activos',
    subscriber: {
      '~BD_CREADA~': 'La base de datos fue creada con éxito'
    },
    sayas: {
      '~NOMBRE~': 'Decir como',
      options: {
        '~CARACTERES~': 'Caracteres',
        '~NUMERO~': 'Número',
        '~CARDINAL~': 'Cardinal',
        '~ORDINAL~': 'Ordinal',
        '~DIGITOS~': 'Dígitos',
        '~FECHA~': 'Fecha'
      }
    },
    callerId: {
      '~IDENTIFICADOR~': 'ID de llamada',
      '~TELEFONO~': 'Número telefónico como ID de llamada',
      '~CLIENTE~': 'ID de cliente como ID de llamada',
      '~SUSCRIPTOR~': 'ID de Suscriptor como ID de llamada'
    },
    '~NO_PAREJA~': 'columna sin emparejar',
    '~NO_CAMPANA~': 'No existen campañas registradas',
    '~NO_ACTIVAS~': 'No existen campañas activas',
    '~SIN_RESULTADOS~': 'No se encontraron campañas con ese criterio',
    '~BUSCAR_CAMPANA~': 'Buscar por nombre o ID...',
    '~NO_RESULTADO~': 'No hubo resultado en búsqueda',
    formula: {
      '~IGUAL~': 'Igual',
      '~MAYOR~': 'Mayor que',
      '~MENOR~': 'Menor que',
      '~MAYOR_IGUAL~': 'Mayor o igual',
      '~MENOR_IGUAL~': 'Menor o igual',
      '~DISTINTO~': 'Distinto',
      '~REGULAR~': 'Regex',
      '~DEFAULT~': 'Defecto',
      '~DEFAULT_NAME~': 'Acción por defecto'
    }
  },
  organization: {
    '~TITULO~': 'Organización',
    '~TITULO_PROGRAMA~': 'Título del Software',
    '~LOGO_PERSONALIZADO~': 'Logo Personalizado',
    '~EDITAR~': 'Editar Organización',
    '~INSERTAR~': 'Nueva Organización',
    '~NOMBRE~': 'Nombre de la Organización',
    '~TELEFONO~': 'Teléfono',
    '~NOMBRE_COMPLETO~': 'Nombre Completo',
    '~SELECCIONADO~': 'Selección',
    '~NO_ORGANIZATION~': 'No existen organizaciones registradas',
    '~IMAGEN_ERROR~': 'EL limite del tamaño ha sido excedido!',
    '~IMAGEN_MENSAJE~': 'Sólo formatos .png y .jpg y tamaño de máximo 5Mg',
    '~IMAGEN_TAMANO~': 'Medidas 264px/120px',
    '~PAÍS~': 'País',
    '~CPS_MÁXIMO~': 'CPS máximo',
    '~PROPIA~': 'Propia',
    '~TELEFONÍA~': 'Telefonía',
    '~Añadir_CPS~': 'Añadir CPS',
    '~CPS_MÁXIMO_ERROR~': 'El CPS del país no puede exceder los CPS de la organización padre en ese país. CPS Máximo: {cps}. País: {country}'
  },
  dialer: {
    '~NOMBRE~': 'Marcadores',
    '~CAPACIDAD~': 'Capacidad',
    '~ACTIVOS~': 'Activos',
    '~NO_MARCADORES~': 'No hay marcadores activos'
  },
  database: {
    '~TITULO~': 'Base de Datos',
    '~EDITAR~': 'Editar Base de Datos',
    '~INSERTAR~': 'Nueva Base de Datos',
    '~NOMBRE~': 'Nombre de Base de Datos',
    '~CREADA~': 'Creada',
    '~ESTADO~': 'Estado',
    '~COLUMNAS~': 'Columnas',
    '~REGISTROS_DE~': 'registros de',
    '~SUSCRIPTORES~': 'Susc.',
    '~BORRAR_SUBS~': 'Eliminar suscriptores que no se encuentre en este nuevo archivo',
    '~EDITAR_SUBS~': 'Actualizar variables en suscriptores existentes',
    '~SUSCRIPTORES_FULL~': 'Suscriptores',
    '~NO_DATABASE~': 'No bases de datos registradas',
    '~NO_RESULTADO~': 'No se obtuvo resultado en la búsqueda',
    '~VARIABLE_PHONE~': 'Debe existir un campo con nombre "phone" para continuar',
    '~VALIDATE_NUMBER~': 'Validar numeración',
    '~COUNTRY~': 'País',
    '~ONLY_CALL_TO_NUMBERS~': 'Solo marcar para números',
    '~DONWLOAD_INVALID_NUMBERS~': '¿Deseas descargar el reporte de números inválidos de la base de datos?'

  },
  report: {
    '~TITULO~': 'Reportes',
    '~EDITAR~': 'Editar Reporte',
    '~INSERTAR~': 'Nueva Reporte',
    '~CREADA~': 'Creada',
    '~ESTADO~': 'Estado',
    '~INFORME_RESUMIDO~': 'Informe Resumido',
    '~INFORME_BASE~': 'Informe Base',
    '~INFORME_DURACION~': 'Informe de Duración',
    '~ENCUESTA~': 'Encuesta',
    '~CONTESTADA~': 'Contestada',
    '~RESPUESTAS~': 'Respuestas',
    '~PROMEDIO_ENCUESTA~': 'Survey Ratio',
    '~OCUPADO~': 'Ocupado',
    '~SEGUNDOS~': 'Segundos',
    '~SEGUNDOS_MIN~': 'Seg',
    '~MINUTOS~': 'Minutos',
    '~MINUTOS_MIN~': 'Min',
    '~NUMERO_INVALIDO~': 'Número Inválido',
    '~NO_REPICO~': 'No Repicó',
    '~NO_CONTESTO~': 'No Contestó',
    '~PROMEDIO_CONTESTO~': 'Porcentaje Contestadas',
    '~DETALLES_INTENTOS~': 'Detalles por Intentos',
    '~INTENTOS~': 'Intento',
    '~DISPOSICION~': 'Disposición',
    '~NUMEROS~': 'Números',
    '~CODIGO_ISDN~': 'Código ISDN',
    '~PRIMERO~': 'Priemro',
    '~ULTIMO~': 'Último',
    '~NO_REPORTE~': 'No bases de datos registradas',
    '~NO_DATA~': 'No hay suficientes datos',
    '~DESCARGAR~': 'Descargar Reportes',
    '~SUMAR_REPORTES~': 'Sumar Reportes',
    '~REPORTE_COMPLETO~': 'Reporte Completo',
    '~SUMADAS~': 'Sumadas',
    '~TITULO_SELECCION~': 'Seleccione las campañas que desea añadir al reporte'
  },
  users: {
    '~EDITAR~': 'Editar Usuario',
    '~INSERTAR~': 'Nuevo Usuario',
    '~NO_USUARIOS~': 'No existen usuarios registrados',
    '~AGREGAR~': 'Agregar Usuario',
    '~TITULO~': 'Lista de Usuarios',
    '~NOMBRE~': 'Nombre',
    '~APELLIDO~': 'Apellido',
    '~CORREO~': 'Correo',
    '~CLAVE~': 'Clave',
    '~TELEFONO~': 'Teléfono',
    '~CELULAR~': 'Celular',
    '~POSICION~': 'Posición',
    '~ID_TARJETA~': 'Tarjeta',
    '~ACTIVO~': 'Activo',
    '~INACTIVO~': 'Inactivo',
    '~ROL~': 'Roles',
    '~ORGANIZACIONES~': 'Organizaciones',
    '~ROLES_TODAS~': 'Actualizar roles en todas las orgs',
    '~ROLES_ACTUAL~': 'Actualizar roles solo para',
    '~ACTUALIZAR_ORGS~': 'Actualizar organizaciones a la cual pertenece el usuario',
    '~BUSCAR~': 'Buscar...',
    '~ETIQUETA_SELECCION~': 'Presiona enter para seleccionar'
  },
  file: {
    '~NOMBRE~': 'Nombre',
    '~NOMBRE_AMIGABLE~': 'Nombre Amigable',
    '~SUBIR~': 'Subir Archivo',
    '~ACEPTABLE~': 'Tipo de archivo aceptable: CSV',
    '~PERMANENTE~': 'Permanente',
    '~DESCARGAR~': 'Descargar Reporte'
  },
  audio: {
    '~AGREGAR~': 'Agregar Audio',
    '~BORRAR~': 'Borrar',
    '~SELECCION~': 'Seleccionar Audio',
    '~REPRODUCIR~': 'Reproducir',
    '~REPRODUCIENDO~': 'Reproduciendo',
    '~DETENER~': 'Parar',
    '~PAUSAR~': 'Pausar',
    '~CONTINUAR~': 'Continuar',
    '~VOZ~': 'Voz',
    '~NOMBRE~': 'Nombre de Audio',
    '~ARCHIVO~': 'Archivo de Audio',
    '~NO_AUDIO~': 'No hubo resultados',
    '~GUARDANDO~': 'Guardando audios'
  },
  action: {
    '~NOMBRE~': 'Acción',
    options: {
      '~COLGAR~': 'Colgar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Empezar',
      '~REPETIR~': 'Repetir'
    }
  },
  step: {
    '~NOMBRE~': 'Paso',
    options: {
      '~TTS~': 'TTS',
      '~PLAYBACK~': 'Reproducir',
      '~RECORD~': 'Grabar',
      '~RECORD_DIGITS~': 'Capturar Tonos',
      '~TRANSFERIR~': 'Transferir',
      '~ASR~': 'Asr',
      '~VARIABLE_WEB~': 'Variable Web',
      '~COLGAR~': 'Colgar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Empezar',
      '~REPETIR~': 'Repetir',
      '~DELAY~': 'Retraso'
    }
  },
  transition: {
    '~NOMBRE~': 'Transición',
    options: {
      '~DIGITOS~': 'Dígitos',
      '~SIGUIENTE~': 'Siguiente',
      '~ASR~': 'ASR',
      '~VARCOMP~': 'Varcomp',
      '~NINGUNO~': 'Ninguno'
    }
  },
  tour: {
    admin: {
      '~NAVEGACION~': '<strong>¡Bienvenido a IPCOM!</strong><br /><br />Te brindamos herramientas de alta tecnología para ayudarte a tomar las mejores decisiones.<br /><br />En el siguiente tour podrás conocer la forma más fácil de utilizar nuestro sistema haciendo clic en  <strong>Siguiente</strong>',
      '~MENU~': 'Selecciona las opciones del menú de forma directa: <strong>Tablero</strong> para las campañas activas, <strong>Organizaciones</strong> que difunden las campañas, <strong>Bases de Datos</strong> de sus afiliados, generación de <strong>Campañas</strong> y <strong>Usuarios</strong> autorizados para crearlas.',
      '~USER_CARD~': 'Indica el perfil o usuario activo para usar el sistema <strong>IPCOM</strong>',
      '~SALIR~': 'Botón para cerrar sesión.',
      '~LISTA_ORG~': 'Lista de selección, úsala para cambiar la organización actual, desde la cual se generarán las campañas y configuraciones en el sistema',
      '~MENU_TABLERO~': '<strong>Tablero</strong><br /><br />Presenta las campañas activas en tiempo real, las últimas campañas procesadas, la base de datos de afiliados, y los audios TTS generados en cada campaña.',
      '~MENU_ORGANIZACION~': '<strong>Organización</strong><br /><br />Muestra las organizaciones clientes y permite registrar nuevas organizaciones, editarlas y eliminarlas.',
      '~MENU_BASEDATOS~': '<strong>Bases de Datos</strong><br /><br />Permite ver, administrar y generar bases de datos de suscriptores utilizadas al momento de crear una campaña.',
      '~MENU_CAMPANA~': '<strong>Campañas</strong><br /><br />Permite ver, crear, administrar y configurar campañas. Supervisa la hora exacta y fecha de generación de cada campaña. Revisa y descarga reportes.',
      '~MENU_USERS~': '<strong>Usuarios</strong><br /><br />Usuarios registrados y autorizados para crear, supervisar, editar y configurar campañas, bases de datos, etc, según el rol y nivel de acceso concedidos.',
      '~BARRA~': 'Barra superior, contiene la página de navegación actual y algunas herramientas.',
      '~IDIOMA~': 'Selección de idioma.',
      '~MENU_IDIOMA~': 'Opciones de lenguaje.',
      '~AYUDA~': 'Activar o desactivar ayudas visuales.',
      '~ACTIVAS~': 'En este panel se muestra los detalles y especificaciones de las campañas activas en tiempo real.',
      '~CAMPANAS~': 'En este panel se encuentran las últimas campañas, activas y/o modificadas.',
      '~SUBSCRIBERS~': 'En este panel se enumeran las bases de datos de suscriptores más recientes creadas o modificadas.',
      '~TTS_AUDIOS~': 'En este panel se muestra los archivos TTS (Tech To Speech) generados en tiempo real, utilizados por la organización en campañas activas y antiguas.',
      organization: {
        '~INTRO~': 'Vista general de las organizaciones registradas en IPCOM con sus datos configurados según la empresa; además de las opciones para agregar nuevas y editar o eliminar las ya existentes.',
        '~BUSCADOR~': 'Escribe el nombre de la organización que quieres buscar.',
        '~INSERTAR~': 'Registra nuevas organizaciones en el sistema.',
        '~TABLA~': 'Cada fila muestra el ID de la organización en el sistema y el nombre legal. También puede editar o eliminar organizaciones ya registradas.',
        '~ACCIONES~': 'Acciones para la gestión de la organización respectiva.',
        '~EDITAR~': 'Edite datos de la organización respectivamente.',
        '~ELIMINAR~': 'Eliminar la organización del sistema después de la confirmación.'
      },
      subscriber: {
        '~INTRO~': 'Selecciona una base de datos ya cargada en el sistema o agrega nuevas bases de datos para tu campaña. <br /><br />Puedes editar o eliminar el banco de datos que requieras, si es necesario.',
        '~BUSCADOR~': 'Escribe el nombre de la base de datos que quieres buscar.',
        '~INSERTAR~': 'Carga nuevas bases de datos al sistema.',
        '~TABLA~': 'Cada fila refleja el nombre de la base de datos, fecha de creación, número de suscriptores y columnas utilizadas en la campaña.',
        '~ACCIONES~': 'Acciones para la gestión de la bases de datos respectiva.',
        '~EDITAR~': 'Editar la configuración de esta base de datos.',
        '~ELIMINAR~': 'Eliminar esta base de datos luego de confirmar.',
        uploadform: {
          '~FORMULARIO~': '<strong>Formulario de Archivo</strong><br /><br /> El archivo CSV (comma-separated values) se utiliza para intercambiar datos en forma de columna de una hoja de cálculo.<br /><br /> Agregue el nombre y cargue el archivo CSV que tiene guardado en su dispositivo.',
          '~ARCHIVO~': 'Click para seleccionar el archivo CSV desde su dispositivo.',
          '~CANCELAR~': 'Cancelar y regresar a la pantalla anterior.',
          '~ENVIAR~': 'Enviar formulario e ir al paso siguiente.'
        },
        import: {
          '~FORMULARIO~': '<strong>Importar Contactos</strong><br /><br /> Antes de importar la base de datos, configure los nombres de las variables contenidas en el archivo CSV cargado anteriormente.',
          '~GRUPO~': 'Cada cuadro representa una columna del archivo CSV cargado anteriormente.',
          '~COLUMNAS~': 'Este cuadro muestra el nombre de la columna, parte de su contenido y opciones de configuración para editar u omitir la variable.',
          '~EDITAR~': 'Haga clic si desea modificar el nombre de la columna.',
          '~OMITIR~': 'Haga clic si desea Omitir esta columna de la base de datos.',
          '~CABECERAS~': 'Permite descartar la primera fila o cabecera del archivo CSV cargado anteriormente.',
          '~CANCELAR~': 'Cancelar e ir al menú anterior.',
          '~GUARDAR~': 'Guardar todos los cambios y generar la nueva Base de Datos de suscriptores.'
        }
      },
      campaign: {
        '~INTRO~': 'Revisa, administra y configura antiguas y nuevas campañas. <br /><br />Supervisa la hora exacta y fecha de generación de las campañas. Revisa y descarga reportes.',
        '~BUSCADOR~': 'Escribe el nombre de la campaña que quieres buscar.',
        '~INSERTAR~': 'Configura una nueva campaña desde cero.',
        '~TABLA~': 'Cada  fila presenta el nombre de una campaña en el sistema, su status, fecha y hora de creación y acciones para su configuración.',
        '~ACCIONES~': 'Acciones para la gestión de la campaña respectiva.',
        '~EDITAR~': 'Edita todos los datos y configuración de la campaña.',
        '~COPIAR~': 'Crea nuevas campañas utilizando clonando el contenido de ésta campaña.',
        '~REPORTES~': 'Indaga datos, estadísticas e información relevante de la campaña.',
        '~DESCARGAS~': 'Descarga el reporte de la campaña en un archivo CSV.',
        '~ARCHIVAR~': 'Archivar el reporte de la campaña.',
        '~CPS_MÁXIMO_ERROR~': 'El valor asignado a los CPS excede el máximo establecido dentro de la organización. CPS Máximo: {cps}',
        steps: {
          '~COFIGURACION~': '<strong>Configuración</strong><br /><br />Escribe correctamente los datos solicitados en cada una de las casillas de registro de la configuración. <br /><br />Estos datos determinan el valor de las variables en la campaña que se va a agregar.',
          '~BASEDATOS~': 'Selecciona una base de datos ya cargada en el sistema o agrega nuevas bases de datos para tu campaña. <br /><br />Puedes editar o eliminar el banco de datos que requieras, si es necesario.',
          '~DIAPLAN~': 'Crea la Campaña que deseas mediante un sistema de pasos.<br /><br /> El Dialplan se organiza por pasos y transiciones.',
          '~ENVIAR~': 'Antes de enviar, verifica que los datos, archivos, audios y solicitudes realizadas han sido cargadaos correctamente.',
          '~NAVEGADOR~': 'Navegue a través de esta barra (breadcrumbs), para encontrar la forma de regresar al paso anterior.',
          '~SELECTOR~': 'Seleccione de esta lista el tipo de paso que le permita configurar correctamente el Dialplan.',
          '~ACTUAL~': 'En esta área se configura el paso actual.<br /><br /> Complete los datos correctamente según el tipo de paso seleccionado para el Dialplan.',
          '~TRANSICION~': 'La transición permite conectar nuevos pasos en la campaña según la configuración que necesite',
          '~ARBOL~': 'Le permite conocer los pasos utilizados durante la configuración la cada campaña.<br /><br /> Puede seleccionar cualquier paso que desee editar.',
          '~PASO_ACTUAL~': 'El resaltado en azul significa el paso que se está editando actualmente.',
          '~PANEL_CONFIG~': 'Resumen de los datos de configuración en el paso 1.',
          '~PANEL_DATABASE~': 'Información de la base de datos de suscriptores que se usará en la campaña.',
          '~PANEL_DIALPLAN~': 'Árbol de pasos que muestra el plan de marcado previamente configurado.',
          '~ENVIAR_FINAL~': 'Click aquí en Enviar, una vez este de acuerdo con la informacíon aquí mostrada.',
          '~SINTETIZAR~': 'En caso de que dentro de su plan de marcado existan audios que se tienen que generar, deberá primero hacer click aquí para proceder a generarlos.'
        }
      },
      user: {
        '~INTRO~': 'Conozca los principales datos de los usuarios registrados y autorizados por su organización para administrar y configurar el sistema.',
        '~BUSCADOR~': 'Explora usuarios por nombre, apellido, número telefónico o correo electrónico.',
        '~INSERTAR~': 'Registrar un nuevo usuario en el sistema.',
        '~TABLA~': 'Cada fila muestra nombres y apellidos del usuario, número de teléfono, email, rol en el sistema, número de tarjeta y status de actividad.',
        '~ACCIONES~': 'Acciones para la gestión de un usuario respectivo.',
        '~ACIVAR~': 'Activar y desactivar usuario.',
        '~EDITAR~': 'Edite datos de usuario respectivamente.',
        '~ELIMINAR~': 'Eliminar usuario del sistema después de la confirmación.'
      }
    }
  }
});

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  global: {
    '~NOMBRE_SISTEMA~': 'IPCOM VORTEX',
    '~FIRMA~': 'IPCOM VORTEX, ©2018.',
    '~ESPANOL~': 'Espanhol',
    '~PORTUGUES~': 'Português',
    '~ITALIANO~': 'Italiano',
    '~FRANCES~': 'Francês',
    '~INGLES~': 'Inglês',
    '~IDIOMA~': 'Idioma',
    '~IDIOMA2~': 'Idioma de Reconhecimento',
    '~MENU~': 'Menu',
    '~TOTALES~': 'Totais',
    '~FINALIZADO~': 'A campanha foi salva',
    '~LOADING~': 'Carregando',
    '~USUARIOS~': 'Usuários',
    '~EDITAR~': 'Editar',
    '~DUPLICAR~': 'Duplicar',
    '~REFRESCAR~': 'Atualizar',
    '~DESACTIVAR~': 'Desativar',
    '~ACTIVAR~': 'Ativar',
    '~AYUDA~': 'Ajuda',
    '~AYUDA_ACTIVADA~': 'Ajudas Ativadas',
    '~AYUDA_DESACTIVADA~': 'Ajudas Inativas',
    '~ACTIVADAS~': 'Mensagens de ajuda ativados',
    '~DESACTIVADAS~': 'Mensagens de ajuda desativados',
    '~CONFIRMAR_AYUDA~': 'Deseja desativar as mensagens de ajuda?',
    '~ACEPTAR~': 'Aceitar',
    '~CONECTANDO~': 'Conectando',
    '~OPCIONES~': 'Opções',
    '~ELIMINAR~': 'Excluir',
    '~REMOVER~': 'Remover',
    '~CANCELAR~': 'Cancelar',
    '~OMITIR~': 'Omitir',
    '~EXPANDIR~': 'Expandir',
    '~AGREGAR~': 'Adicionar',
    '~AVATAR~': 'Avatar',
    '~CONFIGURACION~': 'Configuração',
    '~HOY~': 'Hoje',
    '~SEMANA~': 'Semana',
    '~PERSONALIZAR~': 'Personalizar',
    '~ESTUDIANTE~': 'Estudante',
    '~MASCULINO~': 'Masculino',
    '~FEMENINO~': 'Feminino',
    '~VOLVER~': 'Voltar',
    '~SIGUIENTE~': 'Seguinte',
    '~ANTERIOR~': 'Anterior',
    '~GUARDAR~': 'Salvar',
    '~CERRAR~': 'Fechar',
    '~VALIDA_POR~': 'Válida por',
    '~FAMILIA~': 'Famílias',
    '~AUTORIZADO~': 'Autorizado',
    '~AMIGOS~': 'Amigos',
    '~PERSONAS~': 'Pessoas',
    '~TOKEN~': 'Token',
    '~TOKENS~': 'Tokens',
    '~VEHICULOS~': 'Veículos',
    '~RETIRADAS_AUTORIZADO~': 'Retiradas pelo Autorizado',
    '~HORAS_RETIRADA~': 'Horas de Retirada',
    '~CAMBIAR_CLAVE~': 'Trocar Senha',
    '~EDITAR_PERFIL~': 'Editar Perfil',
    '~HOME~': 'Início',
    '~COFIGURACION~': 'Configuração',
    '~MENU_PRINCIPAL~': 'Menu Principal',
    '~FECHA~': 'Data',
    '~ALUMNOS~': 'Alunos',
    '~INFORMACION~': 'Informação',
    '~FOTO_PERFIL~': 'Foto de Perfil',
    '~FOTO_VEHICULO~': 'Foto do Veículo',
    '~TOMAR_FOTO~': 'Tirar Foto',
    '~SUBIR_ARCHIVO~': 'Subir Arquivo',
    '~REGISTROS~': 'Registros',
    '~ZOOM~': 'Zoom',
    '~DETALLES~': 'Detalhes',
    '~BUSCADOR~': 'Buscar',
    '~SALIR~': 'Sair',
    '~TIPO~': 'Tipo',
    '~CONTINUAR~': 'Continuar',
    '~CONFIRMAR~': 'Confirmar',
    '~FINALIZAR~': 'Finalizar',
    '~ALERTA~': '¡Alerta!',
    '~TITULO~': 'Título',
    '~VOZ~': 'Voz',
    '~NOTA~': 'Nota',
    '~ACCION~': 'Ação',
    '~ACCIONES~': 'Ações',
    '~FILAS~': 'Filas',
    '~DE~': 'De',
    '~A~': 'A',
    '~TEXTO~': 'Texto',
    '~NUMERO~': 'Número',
    '~NEXT_STEP~': 'Passo Seguinte',
    '~CONFIRMAR_BORRAR~': 'Tem certeza que deseja eliminar?',
    '~CONFIRMAR_REMOVER~': 'Tem certeza que deseja remover?',
    '~CONFIRMAR_PARAR~': 'Tem certeza que deseja parar a campanha?',
    '~MENSAJE_REFRESCAR~': 'Advertência! A informação nesta tabela não está atualizada, <br /> por favor dê um click em "Atualizar"',
    relation: {
      '~NOMBRE~': 'Relação',
      options: {
        '~PADRE~': 'Pai',
        '~HIJO~': 'Filho',
        '~RELATIVO~': 'Familiar',
        '~EMPLEADO~': 'Empregado'
      }
    }
  },
  message: {
    '~CORREO_TOMADO~': 'O correio electrônico já está sendo usado'
  },
  login: {
    '~TITULO~': 'Autenticação',
    '~USUARIO~': 'Usuário',
    '~CLAVE~': 'Senha',
    '~NUEVA~': 'Nova Senha',
    '~CORREO~': 'Correio',
    '~ENTRAR~': 'Entrar',
    '~OLVIDO~': 'Esqueceu a Senha?',
    '~RECORDARME~': 'Lembrar de mim',
    '~CONTACTO~': 'Contatar Webmaster',
    '~RECUPERAR~': 'Recuperar Senha',
    '~MENSAJE~': 'Enviamos um correio com as instruções de recuperação',
    '~RECUPERACION_OK~': 'Sua senha foi modificada com sucesso',
    '~ENVIAR~': 'Enviar',
    '~VOLVER~': 'Voltar',
    '~RESETEAR~': 'Reset da Senha',
    '~VERIFICAR~': 'Verificar Senha',
    '~BIENVENIDO~': 'Bem-vindo ao Sistema IPCOM',
    '~NO_AUTORIZADO~': 'Desculpe! O correio ou a senha estão incorretos',
    '~NO_AUTENTICADO~': 'Desculpe! Você não encontra-se autenticado',
    '~EXITOSO~': 'Início de sessão bem sucedido',
    '~NO_USUARIO~': 'Erro! Este usuário não existe'
  },
  menu: {
    '~INICIO~': 'Início',
    '~TABLERO~': 'Painel',
    '~CAMPAGNA~': 'Campanhas',
    '~BASE_DATOS~': 'Bases de Dados',
    '~ORGANIZACION~': 'Organizações',
    '~USUARIOS~': 'Usuários',
    '~REPORTES~': 'Relatórios',
    '~CONFIGURACION~': 'Configuração',
    '~CAMPAGNA_ABIERTA~': 'Campanhas abertas'
  },
  campaign: {
    '~CAMPAGNA~': 'Campanha',
    '~IDIOMA~': 'Idioma',
    '~EDITAR~': 'Editar Campanha',
    '~INSERTAR~': 'Nova Campanha',
    '~NOMBRE~': 'Nome de Campanha',
    '~CAMPAGNA_ABIERTA~': 'Mode de campanha aberta',
    '~CERRAR~': 'Fechar campanha',
    '~TTS_MENSAJE2~': 'Mensagem TTS anterior',
    '~GUARDANDO~': 'Salvando campanha',
    '~SUSCRIPTORES~': 'Base de Dados Subscritos',
    '~PASO~': 'Passo',
    '~ESTADO~': 'Estado',
    '~ARBOL~': 'Árvore de Navegação',
    '~TRANSICION~': 'Transição',
    '~DIGITOS~': 'Dígitos',
    '~VARIABLE_NOMBRE~': 'Nome Variável',
    '~TIEMPO~': 'Tempo',
    '~COMANDO_VOZ~': 'Voz',
    '~BASE_DATOS~': 'Base de Dados',
    '~LLAMADAS~': 'Ligações simultâneas',
    '~INTERACCION~': 'Interação',
    '~TASA_CONTACTO~': 'Percentual de contatação',
    '~PREFIJO~': 'Prefixo de Discagem',
    '~REJECT_CODES~': 'Códigos de Rejeição RDSI',
    '~GRUPOS_RUTAS~': 'Grupos de Rotas',
    '~IDENTIFICADOR~': 'ID de Ligação',
    '~ID_CLIENTE~': 'ID Cliente',
    '~TIEMPO_ESPERA~': 'Tempo de Espera',
    '~TIEMPO_DIGITOS~': 'Tempo de Espera de Dígito',
    '~TIEMPO_REINTENTO~': 'Tempo de Nova Tentativa',
    '~MAQUINA_RESPUESTA~': 'Detecção de caixa postal',
    '~MAQUINA_RESPUESTA_TOOLTIP~': 'Detecta automaticamente secretárias eletrônicas (AMD) e caixa postal.',
    '~MAQUINA_COLGAR~': 'Máquina de Detecção de Respostas Desligar',
    '~MAQUINA_COLGAR_TOOLTIP~': 'Encerra a chamada ao detectar caixa postal.',
    '~TITULO~': 'Título',
    '~TODAS~': 'Todas',
    '~TTS_MENSAJE~': 'Mensagem TTS',
    '~PREFIJO_ARCHIVO~': 'Prefixo de Arquivo',
    '~MAXIMA_LONGITUD~': 'Máxima Longitude',
    '~REPETIR~': 'Repetir',
    '~FINAL~': '# Ao Final',
    '~IMPORTAR~': 'Importar Contatos',
    '~IMPORTAR_CVS~': 'Importar novos registros',
    '~IMPORTAR_DESC~': 'Agora juntaremos as colunas do arquivo carregado com sua lista de Subscritos',
    '~OMITIR_CABECERAS~': 'Sem Cabeçalhos',
    '~NUEVA_COLUMNA~': 'Novo nome',
    '~INTENTOS_MAXIMOS~': 'Máximo de Tentativas',
    '~PROXIMO_REINTENTO~': 'PRI',
    '~INTENTOS_ALCANZADOS~': 'Número máximo de tentativas alcançadas',
    '~LLAMADAS_ALCANZADOS~': 'Número máximo de ligações alcançadas',
    '~INTENTOS_MAX~': 'Máx. Tentativas',
    '~MAXIMO_ALCANZADO~': 'Limite máximo alcançado',
    '~CANALES_MAXIMOS~': 'Canais Máximos',
    '~ZONA_HORARIA~': 'Fuso Horário',
    '~COLGAR_NO_RESP~': 'Desligar se não tem resposta',
    '~EXTENSION~': 'Ramal',
    '~MINIMO_HORA~': 'Hora Mínima',
    '~MAXIMO_HORA~': 'Hora Máxima',
    '~SELECCIONAR_FECHA~': 'Selecionar Data',
    '~FECHA_COMIENZO~': 'Data Início',
    '~FECHA_FINAL~': 'Data Final',
    '~FECHA_ERROR~': 'A data de início deve ser anterior que a data final.',
    '~FECHA_CREACION~': 'Data de Criação',
    '~ACTIVAS~': 'Campanhas Ativas',
    '~ULTIMAS~': 'Últimas Campanhas',
    '~BASES_MONITOREADAS~': 'Bases Monitoradas',
    '~NUMEROS~': 'Números',
    '~EN_COLA~': 'Em fila',
    '~MARCADO~': 'Marcado',
    '~CONTACTO~': 'Contato',
    '~VER~': 'Ver',
    '~ACTIVA~': 'Ativo / Máx',
    '~SILENCIO~': 'Silêncio',
    '~REPETICIONES~': 'Número de Repetições',
    '~AUDIO_INVALIDO~': 'Áudio de nova tentativa',
    '~FRASE~': 'Frase',
    '~VARIABLE~': 'Variável',
    '~FORMULA~': 'Fórmula',
    '~GENERACION_TTS~': 'Geração de TTS',
    '~GENERAR_AUDIOS~': 'Sintetizar Áudios',
    '~PROBAR_AUDIO~': 'Provar TTS',
    '~DESCARGAR_TTS~': 'Descarregar TTS',
    '~ARCHIVAR~': 'Arquivar',
    '~OPERADOR~': 'Agente',
    '~AYUDA_VARCOMP~': 'Sintáxe códigos avançados',
    '~VOICES2_NOT_FOUND~': 'Não há vozes para o idioma selecionado.',
    subscriber: {
      '~BD_CREADA~': 'A base de dados foi criada com sucesso'
    },
    sayas: {
      '~NOMBRE~': 'Dizer como',
      options: {
        '~CARACTERES~': 'Caracteres',
        '~NUMERO~': 'Número',
        '~CARDINAL~': 'Cardinal',
        '~ORDINAL~': 'Ordinal',
        '~DIGITOS~': 'Dígitos',
        '~FECHA~': 'Data'
      }
    },
    callerId: {
      '~IDENTIFICADOR~': 'ID de llamada',
      '~TELEFONO~': 'Número telefónico como ID de llamada',
      '~CLIENTE~': 'ID de cliente como ID de llamada',
      '~SUSCRIPTOR~': 'ID de Suscriptor como ID de llamada'
    },
    '~NO_PAREJA~': 'coluna sem par',
    '~NO_CAMPANA~': 'Não existen campanhas registradas',
    '~NO_ACTIVAS~': 'Não existen campanhas ativas',
    '~SIN_RESULTADOS~': 'Nenhuma campanha encontrada com esse critério',
    '~BUSCAR_CAMPANA~': 'Pesquisar por nome ou ID...',
    '~NO_RESULTADO~': 'Não teve resultado na busca',
    formula: {
      '~IGUAL~': 'Igual',
      '~MAYOR~': 'Maior que',
      '~MENOR~': 'Menor que',
      '~MAYOR_IGUAL~': 'Maior ou igual',
      '~MENOR_IGUAL~': 'Menor ou igual',
      '~DISTINTO~': 'Distinto',
      '~REGULAR~': 'Regular',
      '~DEFAULT~': 'Default',
      '~DEFAULT_NAME~': 'Ação por default'
    }
  },
  organization: {
    '~TITULO~': 'Organização',
    '~EDITAR~': 'Editar Organização',
    '~INSERTAR~': 'Nova Organização',
    '~NOMBRE~': 'Nome da Organização',
    '~TELEFONO~': 'Telefone',
    '~NOMBRE_COMPLETO~': 'Nome Completo',
    '~IMAGEN_ERROR~': 'O limite de tamanho foi excedido!',
    '~IMAGEN_MENSAJE~': 'Somente formatos .png e .jpg são permitidos. Tamanho máximo 5mb.',
    '~IMAGEN_TAMANO~': 'O tamanho deve ser 264px / 120px',
    '~TITULO_PROGRAMA~': 'Título do software',
    '~LOGO_PERSONALIZADO~': 'Logotipo personalizado',
    '~SELECCIONADO~': 'Seleção',
    '~NO_ORGANIZATION~': 'Não existen organizações registradas',
    '~PAÍS~': 'País',
    '~CPS_MÁXIMO~': 'CPS máximo',
    '~PROPIA~': 'Próprio',
    '~TELEFONÍA~': 'Telefonia',
    '~Añadir_CPS~': 'Adicionar CPS',
    '~CPS_MÁXIMO_ERROR~': 'O CPS do país não pode exceder o CPS da organização controladora naquele país'
  },
  dialer: {
    '~NOMBRE~': 'Discadores',
    '~CAPACIDAD~': 'Capacidade',
    '~ACTIVOS~': 'Ativos',
    '~NO_MARCADORES~': 'Não há Discadores ativos'
  },
  database: {
    '~TITULO~': 'Base de Dados',
    '~EDITAR~': 'Editar Base de Dados',
    '~INSERTAR~': 'Nova Base de Dados',
    '~NOMBRE~': 'Nome de Base de Dados',
    '~CREADA~': 'Criada',
    '~REGISTROS_DE~': 'Registros de',
    '~ESTADO~': 'Estado',
    '~COLUMNAS~': 'Colunas',
    '~SUSCRIPTORES~': 'Subscritos',
    '~BORRAR_SUBS~': 'Eliminar subscritos que não se encontrem neste novo arquivo',
    '~EDITAR_SUBS~': 'Atualizar variáveis em suscritos existentes',
    '~SUSCRIPTORES_FULL~': 'Subscritos',
    '~NO_DATABASE~': 'Não existem bases de dados registradas',
    '~NO_RESULTADO~': 'Não obteve-se resultado na busca',
    '~VARIABLE_PHONE~': 'Deve existir um campo con nome "phone" para continuar',
    '~VALIDATE_NUMBER~': 'Validar numeração',
    '~COUNTRY~': 'País',
    '~ONLY_CALL_TO_NUMBERS~': 'Disque apenas para números',
    '~DONWLOAD_INVALID_NUMBERS~': 'Deseja baixar o relatório de números inválidos do banco de dados?'
  },
  report: {
    '~TITULO~': 'Relatórios',
    '~EDITAR~': 'Editar Relatório',
    '~INSERTAR~': 'Novo Relatório',
    '~CREADA~': 'Criada',
    '~ESTADO~': 'Estado',
    '~INFORME_RESUMIDO~': 'Relatório Resumido',
    '~INFORME_BASE~': 'Relatório Base',
    '~INFORME_DURACION~': 'Relatório de Duração',
    '~ENCUESTA~': 'Enquete',
    '~CONTESTADA~': 'Atendida',
    '~RESPUESTAS~': 'Respostas',
    '~PROMEDIO_ENCUESTA~': 'Números da Enquete',
    '~OCUPADO~': 'Ocupado',
    '~SEGUNDOS~': 'Segundos',
    '~SEGUNDOS_MIN~': 'Seg',
    '~MINUTOS~': 'Minutos',
    '~MINUTOS_MIN~': 'Min',
    '~NUMERO_INVALIDO~': 'Número Inválido',
    '~NO_REPICO~': 'Não tocou',
    '~NO_CONTESTO~': 'Não Atendeu',
    '~PROMEDIO_CONTESTO~': 'Porcentagem Atendidas',
    '~DETALLES_INTENTOS~': 'Detalhes por Tentativas',
    '~INTENTOS~': 'Tentativa',
    '~DISPOSICION~': 'Disposição',
    '~NUMEROS~': 'Números',
    '~CODIGO_ISDN~': 'Código ISDN',
    '~PRIMERO~': 'Primeiro',
    '~ULTIMO~': 'Último',
    '~NO_REPORTE~': 'Não existem bases de dados registradas',
    '~NO_DATA~': 'Não há dados suficientes',
    '~DESCARGAR~': 'Descarregar Relatórios',
    '~SUMAR_REPORTES~': 'Somar Relatórios',
    '~REPORTE_COMPLETO~': 'Relatório Completo',
    '~SUMADAS~': 'Somas',
    '~TITULO_SELECCION~': 'Selecione as campanhas que deseja adicionar ao relatório'
  },
  users: {
    '~EDITAR~': 'Editar Usuário',
    '~INSERTAR~': 'Novo Usuário',
    '~NO_USUARIOS~': 'Não existen usuários registrados',
    '~AGREGAR~': 'Adicionar Usuário',
    '~TITULO~': 'Lista de Usuários',
    '~NOMBRE~': 'Nome',
    '~APELLIDO~': 'Sobrenome',
    '~CORREO~': 'Correio',
    '~CLAVE~': 'Senha',
    '~TELEFONO~': 'Telefone',
    '~CELULAR~': 'Celular',
    '~POSICION~': 'Posição',
    '~ID_TARJETA~': 'Cartão',
    '~ACTIVO~': 'Ativo',
    '~INACTIVO~': 'Inativo',
    '~ROL~': 'Funções',
    '~ORGANIZACIONES~': 'Organizações',
    '~ROLES_TODAS~': 'Atualizar funções em todas as organizações',
    '~ROLES_ACTUAL~': 'Atualizar funções somente para',
    '~ACTUALIZAR_ORGS~': 'Atualizar organizações para a qual pertence o usuário',
    '~BUSCAR~': 'Buscar...',
    '~ETIQUETA_SELECCION~': 'Digite enter para selecionar'
  },
  file: {
    '~NOMBRE~': 'Nome',
    '~NOMBRE_AMIGABLE~': 'Nome Amigável',
    '~SUBIR~': 'Subir Arquivo',
    '~ACEPTABLE~': 'Tipo de arquivo "aceitável" : CSV',
    '~PERMANENTE~': 'Permanente',
    '~DESCARGAR~': 'Descarregar Relatório'
  },
  audio: {
    '~AGREGAR~': 'Agregar Áudio',
    '~BORRAR~': 'Apagar',
    '~SELECCION~': 'Selecionar Áudio',
    '~REPRODUCIR~': 'Reproduzir',
    '~REPRODUCIENDO~': 'Reproduzindo',
    '~DETENER~': 'Parar',
    '~PAUSAR~': 'Pausar',
    '~GUARDANDO~': 'Salvando áudios',
    '~CONTINUAR~': 'Continuar',
    '~VOZ~': 'Voz',
    '~NOMBRE~': 'Nome do Áudio',
    '~ARCHIVO~': 'Arquivo de Áudio',
    '~NO_AUDIO~': 'Não teve resultados'
  },
  action: {
    '~NOMBRE~': 'Ação',
    options: {
      '~COLGAR~': 'Desligar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Começar',
      '~REPETIR~': 'Repetir'
    }
  },
  step: {
    '~NOMBRE~': 'Passo',
    '~GUARDAR~': 'Guardar passo',
    options: {
      '~TTS~': 'TTS',
      '~PLAYBACK~': 'Reproduzir',
      '~RECORD~': 'Gravar',
      '~RECORD_DIGITS~': 'Gravar Dígitos',
      '~TRANSFERIR~': 'Transferir',
      '~VARIABLE_WEB~': 'Variável Web',
      '~COLGAR~': 'Desligar',
      '~RETORNAR~': 'Retornar',
      '~EMPEZAR~': 'Começar',
      '~REPETIR~': 'Repetir',
      '~ASR~': 'ASR',
      '~DELAY~': 'DEMORA'
    }
  },
  transition: {
    '~NOMBRE~': 'Transição',
    options: {
      '~DIGITOS~': 'Dígitos',
      '~SIGUIENTE~': 'Seguinte',
      '~ASR~': 'ASR',
      '~VARCOMP~': 'Varcomp',
      '~NINGUNO~': 'Nenhum'
    }
  },
  tour: {
    admin: {
      '~NAVEGACION~': '<strong>¡Bem-vindo à IPCOM!</strong><br /><br />Fornecemos a você ferramentas de alta tecnología para lhe ajudar a tomar as melhores decisões.<br /><br />No seguinte tour você poderá conhecer a forma mais fácil de utilizar o nosso sistema fazendo click em  <strong>Seguinte</strong>',
      '~MENU~': 'Selecione as opções do menu de forma "direta" : <strong>Painel</strong> para as campanhas ativas, <strong>Organizações</strong> que difundem as campanhas, <strong>Bases de Dados</strong> dos seus filiados, geração de <strong>Campanhas</strong> e <strong>Usuários</strong> autorizados para criá-las.',
      '~USER_CARD~': 'Indica o perfil do usuário ativo para usar o sistema <strong>IPCOM</strong>',
      '~SALIR~': 'Botão para fechar sessão.',
      '~LISTA_ORG~': 'Lista de seleção, use-a para trocar a organização atual, desde a qual se gerarão as campanhas e configurações no sistema',
      '~MENU_TABLERO~': '<strong>Painel</strong><br /><br />Apresenta as campanhas ativas em tempo real, as últimas campanhas processadas, a base de dados de filiados, e os áudios TTS gerados em cada campanha.',
      '~MENU_ORGANIZACION~': '<strong>Organização</strong><br /><br />Mostra as organizações clientes e permite registrar novas organizações, editá-las e eliminá-las.',
      '~MENU_BASEDATOS~': '<strong>Bases de Dados</strong><br /><br />Permite ver, administrar e gerar bases de dados de subscritos utilizadas no momento de criar una campanha.',
      '~MENU_CAMPANA~': '<strong>Campanhas</strong><br /><br />Permite ver, criar, administrar e configurar campanhas. Supervisa a hora exata e data de geração de cada campanha. Revisa e descarrega relatórios.',
      '~MENU_USERS~': '<strong>Usuários</strong><br /><br />Usuários registrados e autorizados para criar, supervisar, editar e configurar campanhas, bases de dados, etc, segundo a função e o nível de acesso concedidos.',
      '~BARRA~': 'Barra superior, contem a página de navegação atual e algumas ferramentas.',
      '~IDIOMA~': 'Seleção de idioma.',
      '~MENU_IDIOMA~': 'Opções de Idioma.',
      '~AYUDA~': 'Ativar ou desativar ajudas visuais.',
      '~ACTIVAS~': 'Neste painel mostra-se os detalhes e especificações das campanhas ativas em tempo real.',
      '~CAMPANAS~': 'Neste painel encontram-se as últimas campanhas, ativas e/ou modificadas.',
      '~SUBSCRIBERS~': 'Neste painel enumeram-se as bases de dados de subscritos mais recentes criadas ou modificadas.',
      '~TTS_AUDIOS~': 'Neste painel mostra-se os arquivos TTS (Tech To Speech) gerados em tempo real, utilizados pela organização em campanhas ativas e antigas.',
      organization: {
        '~INTRO~': 'Vista geral das organizações registradas em IPCOM com seus dados configurados segundo a empresa; além das opções para adicionar novas e editar ou eliminar as já existentes.',
        '~BUSCADOR~': 'Escreve o nome da organização que deseja procurar',
        '~INSERTAR~': 'Registra novas organizações no sistema.',
        '~TABLA~': 'Cada fila mostra o ID da organização no sistema e o nome legal. Também pode editar ou eliminar organizações já registradas.',
        '~ACCIONES~': 'Ações para a gestão da organização respectiva.',
        '~EDITAR~': 'Edite dados da organização respectivamente.',
        '~ELIMINAR~': 'Eliminar a organização do sistema depois da confirmação'
      },
      subscriber: {
        '~INTRO~': 'Seleciona uma base de dados já carregada no sistema ou adiciona novas bases de dados para a sua campanha. <br /><br />Você pode editar ou eliminar o banco de dados que requerer, se for necessário.',
        '~BUSCADOR~': 'Escreve o nome da base de dados que deseja buscar',
        '~INSERTAR~': 'Carrega novas bases de dados ao sistema.',
        '~TABLA~': 'Cada fila reflete o nome da base de dados, data de criação, número de subscritos e colunas utilizadas na campanha.',
        '~ACCIONES~': 'Ações para a gestão da base de dados respectiva.',
        '~EDITAR~': 'Editar a configuração desta base de dados.',
        '~ELIMINAR~': 'Eliminar esta base de dados depois de confirmar.',
        uploadform: {
          '~FORMULARIO~': '<strong>Formulário de Arquivo</strong><br /><br /> O arquivo CSV (comma-separated values) utiliza-se para o intercâmbio de dados em forma de coluna de uma planilha de cálculo.<br /><br /> Adicione o nome e carregue o arquivo CSV que salvou no seu dispositivo.',
          '~ARCHIVO~': 'Click para selecionar o arquivo CSV desde o seu dispositivo.',
          '~CANCELAR~': 'Cancelar e retornar à tela anterior.',
          '~ENVIAR~': 'Enviar formulário e ir ao passo seguinte.'
        },
        import: {
          '~FORMULARIO~': '<strong>Importar Contatos</strong><br /><br /> Antes de importar a base de dados, configure os nomes das variáveis contidas no arquivo CSV carregado anteriormente.',
          '~GRUPO~': 'Cada quadro representa uma coluna do arquivo CSV carregado anteriormente.',
          '~COLUMNAS~': 'Este quadro mostra o nome da coluna, parte do seu conteúdo e opções de configuração para editar ou omitir a variável.',
          '~EDITAR~': 'Faça click se deseja modificar o nome da coluna.',
          '~OMITIR~': 'Fala click se deseja Omitir esta coluna da base de dados.',
          '~CABECERAS~': 'Permite descartar a primeira fila ou cabeçalho do arquivo CSV carregado anteriormente.',
          '~CANCELAR~': 'Cancelar e ir ao menu anterior.',
          '~GUARDAR~': 'Salvar todas as mudanças e gerar a nova Base de Dados de subscritos.'
        }
      },
      campaign: {
        '~INTRO~': 'Revisa, administra e configura antigas e novas campanhas. <br /><br />Supervisa a hora exata e data de geração das campanhas. Revisa e descarrega relatórios.',
        '~BUSCADOR~': 'Escreve o nome da campanha que deseja buscar.',
        '~INSERTAR~': 'Configura uma nova campanha desde zero.',
        '~TABLA~': 'Cada  fila apresenta o nome de uma campanha no sistema, seu status, data e hora de criação e ações para sua configuração.',
        '~ACCIONES~': 'Ações para a gestão da campanha respectiva.',
        '~EDITAR~': 'Edita todos os dados e configuração da campanha.',
        '~COPIAR~': 'Cria novas campanhas utilizando ou clonando o conteúdo desta campanha.',
        '~REPORTES~': 'Procura dados, estatísticas e informação relevante da campanha.',
        '~DESCARGAS~': 'Descarrega o relatório da campanha num arquivo CSV.',
        '~ARCHIVAR~': 'Arquiva o relatório da campanha.',
        '~CPS_MÁXIMO_ERROR~': 'O valor atribuído ao CPS ultrapassa o máximo estabelecido dentro da organização. CPS máximo: {cps}.',
        steps: {
          '~COFIGURACION~': '<strong>Configuração</strong><br /><br />Escreve corretamente os dados solicitados em cada um dos campos de registro da configuração. <br /><br />Esses dados determinam o valor das variáveis na campanha que vai se adicionar.',
          '~BASEDATOS~': 'Seleciona uma base de dados já carregada no sistema e adiciona novas bases de dados para sua campanha. <br /><br />Você pode editar ou eliminar o banco de dados que requerir, se for necessário.',
          '~DIAPLAN~': 'Cria a Campanha que deseja mediante um sistema de passos.<br /><br /> O Dialplan  organiza-se por passos e transições.',
          '~ENVIAR~': 'Antes de enviar, verifica que os dados, arquivos, áudios e solicitações realizadas tenham sido carregados corretamente.',
          '~NAVEGADOR~': 'Navegue através desta barra (breadcrumbs), para encontrar a forma de retornar ao passo anterior.',
          '~SELECTOR~': 'Selecione desta lista o tipo de passo que lhe permita configurar corretamente o Dialplan.',
          '~ACTUAL~': 'Nesta área configura-se o passo atual.<br /><br /> Complete os dados corretamente segundo o tipo de passo selecionado para o Dialplan.',
          '~TRANSICION~': 'A transição permite conectar novos passos na campanha segundo a configuração que precise',
          '~ARBOL~': 'Permite conhecer os passos utilizados durante a configuração de cada campanha.<br /><br /> Pode selecionar qualquer passo que deseje editar.',
          '~PASO_ACTUAL~': 'O resultado em azul significa o passo que se está editando atualmente.',
          '~PANEL_CONFIG~': 'Resumo dos dados da configuração no passo 1.',
          '~PANEL_DATABASE~': 'Informação da base de dados de subscritos que se usará na campanha.',
          '~PANEL_DIALPLAN~': 'Árvore de passos que mostra o plano de discagem previamente configurado.',
          '~ENVIAR_FINAL~': 'Click aquí em Enviar, uma vez esteja de acordo com a informação aquí mostrada.',
          '~SINTETIZAR~': 'Em caso de que dentro do seu plano de discagem existam áudios que se têm que gerar, deverá primeiro fazer click aquí para gerá-los.'
        }
      },
      user: {
        '~INTRO~': 'Conheça os principais dados dos usuários registrados e autorizados pela sua organização para administrar e configurar o sistema.',
        '~BUSCADOR~': 'Explora usuários por nome, sobrenome, número telefônico ou correio electrônico.',
        '~INSERTAR~': 'Registrar um novo usuário no sistema.',
        '~TABLA~': 'Cada fila mostra nomes e sobrenomes do usuário, número de telefone, email, função no sistema, número de cartão e status de actividade.',
        '~ACCIONES~': 'Ações para a gestão de um usuário respectivo.',
        '~ACIVAR~': 'Ativar e desativar usuário.',
        '~EDITAR~': 'Edite dados de usuário respectivamente.',
        '~ELIMINAR~': 'Eliminar usuário do sistema depois da confirmação'
      }
    }
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_components_mdCore_index_css__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_components_mdCore_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_components_mdCore_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_components_mdAvatar_index_css__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_components_mdAvatar_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_components_mdAvatar_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_components_mdButton_index_css__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_dist_components_mdButton_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material_dist_components_mdButton_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components_mdCard_index_css__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components_mdCard_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_components_mdCard_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_components_mdCheckbox_index_css__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_components_mdCheckbox_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_dist_components_mdCheckbox_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_components_mdChips_index_css__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_components_mdChips_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_components_mdChips_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_dist_components_mdDialog_index_css__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_dist_components_mdDialog_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_material_dist_components_mdDialog_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_components_mdFile_index_css__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_dist_components_mdFile_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_material_dist_components_mdFile_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_dist_components_mdIcon_index_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_dist_components_mdIcon_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_material_dist_components_mdIcon_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_dist_components_mdInputContainer_index_css__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_dist_components_mdInputContainer_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_material_dist_components_mdInputContainer_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_dist_components_mdList_index_css__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_dist_components_mdList_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_material_dist_components_mdList_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_material_dist_components_mdMenu_index_css__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_material_dist_components_mdMenu_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_material_dist_components_mdMenu_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_material_dist_components_mdProgress_index_css__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_material_dist_components_mdProgress_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_material_dist_components_mdProgress_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_material_dist_components_mdRadio_index_css__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_material_dist_components_mdRadio_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_material_dist_components_mdRadio_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_material_dist_components_mdSelect_index_css__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_material_dist_components_mdSelect_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_material_dist_components_mdSelect_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_material_dist_components_mdSidenav_index_css__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_material_dist_components_mdSidenav_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_material_dist_components_mdSidenav_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_material_dist_components_mdSnackbar_index_css__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_material_dist_components_mdSnackbar_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_material_dist_components_mdSnackbar_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_material_dist_components_mdSpinner_index_css__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_material_dist_components_mdSpinner_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_material_dist_components_mdSpinner_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_material_dist_components_mdStepper_index_css__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_material_dist_components_mdStepper_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_material_dist_components_mdStepper_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_material_dist_components_mdSubheader_index_css__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_material_dist_components_mdSubheader_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_material_dist_components_mdSubheader_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_material_dist_components_mdTable_index_css__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_material_dist_components_mdTable_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_material_dist_components_mdTable_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_material_dist_components_mdToolbar_index_css__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_material_dist_components_mdToolbar_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_material_dist_components_mdToolbar_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_material_dist_components_mdTooltip_index_css__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_material_dist_components_mdTooltip_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_material_dist_components_mdTooltip_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_material_dist_components_mdDivider_index_css__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_material_dist_components_mdDivider_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_material_dist_components_mdDivider_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_material_dist_components_mdBackdrop_index_css__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_material_dist_components_mdBackdrop_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_material_dist_components_mdBackdrop_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_material_dist_components_mdLayout_index_css__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_material_dist_components_mdLayout_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_material_dist_components_mdLayout_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_material_dist_components_mdWhiteframe_index_css__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_material_dist_components_mdWhiteframe_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_material_dist_components_mdWhiteframe_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_tour_dist_tour_css__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_tour_dist_tour_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_tour_dist_tour_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__App__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__router__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__store__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__i18n__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vee_validate__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_material__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__i18n_vee__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_events__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vue_chartist__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vue_chartist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_vue_chartist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__fonts_material_icons_material_icons_css__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__fonts_material_icons_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__fonts_material_icons_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__fonts_roboto_roboto_css__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__fonts_roboto_roboto_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__fonts_roboto_roboto_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__stylesheets_chartist_css__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__stylesheets_chartist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__stylesheets_chartist_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_datetime__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_page_content__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_page_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_page_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_sidenav__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_sidenav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_sidenav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__config__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_vue_truncate_filter__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_vue_truncate_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_vue_truncate_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_vue_js_popover__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_axios_retry__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_axios_retry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_axios_retry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__store_mutation_types__ = __webpack_require__(20);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.























































// install globally
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdCore);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdAvatar);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdButton);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdCard);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdCheckbox);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdChips);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdDialog);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdFile);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdIcon);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdInputContainer);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdList);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdMenu);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdProgress);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdRadio);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdSelect);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdSidenav);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdSnackbar);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdSpinner);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdStepper);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdSubheader);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdTable);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdToolbar);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdTooltip);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdDivider);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdBackdrop);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdLayout);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_material___default.a.MdWhiteframe);

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_52_vue_js_popover___default.a);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_46_vue_datetime___default.a);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_51_vue_truncate_filter___default.a);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_42_vue_chartist___default.a);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38_vee_validate__["a" /* default */], {
  locale: 'es',
  dictionary: __WEBPACK_IMPORTED_MODULE_40__i18n_vee__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].material.registerTheme({
  global: {
    primary: {
      color: 'blue',
      hue: '600'
    },
    accent: 'deep-orange',
    warn: 'deep-orange',
    background: 'white'
  },
  white: {
    primary: 'white',
    accent: 'blue'
  },
  'light-blue': {
    primary: 'light-blue'
  }
});

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].component('page-content', __WEBPACK_IMPORTED_MODULE_47__components_page_content___default.a);
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].component('sidenav', __WEBPACK_IMPORTED_MODULE_48__components_sidenav___default.a);

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.STEP_TYPES = __WEBPACK_IMPORTED_MODULE_49__config__["a" /* STEP_TYPES */];
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.TRANSITIONS = __WEBPACK_IMPORTED_MODULE_49__config__["b" /* TRANSITIONS */];
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.WAIT_TIME_LIMIT = __WEBPACK_IMPORTED_MODULE_49__config__["c" /* WAIT_TIME_LIMIT */];
__WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.RETRY_TIME_LIMIT = __WEBPACK_IMPORTED_MODULE_49__config__["d" /* RETRY_TIME_LIMIT */];

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_50_moment___default()(String(value)).format('MM/DD/YYYY hh:mm');
  }
});

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].directive('enable-if-roles', {
  inserted: function inserted(el, binding, vnode) {
    el.disabled = !vnode.context.$store.getters.hasRoles(binding.value);
  }
});

__WEBPACK_IMPORTED_MODULE_32_vue__["default"].directive('show-if-roles', {
  inserted: function inserted(el, binding, vnode) {
    var cond = vnode.context.$store.getters.hasRoles(binding.value);
    cond ? el.style.visibility = 'visible' : el.style.visibility = 'hidden';
  }
});

__WEBPACK_IMPORTED_MODULE_53_axios_retry___default()(__WEBPACK_IMPORTED_MODULE_37_axios___default.a, { retries: 5,
  retryDelay: function retryDelay(count) {
    return Math.pow(2, count) * 500;
  },

  retryCondition: __WEBPACK_IMPORTED_MODULE_53_axios_retry__["isSafeRequestError"]
});

__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_49__config__["e" /* getConfig */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_49__config__["f" /* getLogo */])()]).then(function (_ref) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
      config = _ref2[0],
      logo = _ref2[1];

  __WEBPACK_IMPORTED_MODULE_35__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_54__store_mutation_types__["a" /* SET_GLOBAL_LOGO */], logo);
  __WEBPACK_IMPORTED_MODULE_35__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_54__store_mutation_types__["b" /* SET_GLOBAL_TITLE */], config.softwareTitle);
  var backendUrl = config.backendBaseURL;
  __WEBPACK_IMPORTED_MODULE_37_axios___default.a.defaults.baseURL = backendUrl;
  __WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.$backendBaseURL = backendUrl;
  __WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.$wsBaseUrl = config.wsBaseURL;
  __WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.$softwareTitle = config.softwareTitle;
  __WEBPACK_IMPORTED_MODULE_32_vue__["default"].prototype.$logoCompany = logo;
  var app = new __WEBPACK_IMPORTED_MODULE_32_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_34__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_35__store__["a" /* default */],
    i18n: __WEBPACK_IMPORTED_MODULE_36__i18n__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_33__App___default.a }
  });

  __WEBPACK_IMPORTED_MODULE_34__router__["a" /* default */].beforeEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_32_vue__["default"].nextTick(function () {
      var mainContent = document.querySelector('.main-content');

      if (mainContent) {
        mainContent.scrollTop = 0;
      }
      app.$events.$emit('closeSidenav');
      next();
    });
  });
}).catch(function () {
  new __WEBPACK_IMPORTED_MODULE_32_vue__["default"]({ //eslint-disable-line
    el: '#app',
    template: '<p>Error General</p>'
  });
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_difference__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_union__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pick__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__base64__ = __webpack_require__(239);





var _mutations;











var axiosExternal = __WEBPACK_IMPORTED_MODULE_11_axios___default.a.create({ baseURL: '', headers: { common: [] } });
delete axiosExternal.defaults.headers.common['Authorization'];

var state = {
  audioFiles: [],
  audioFilesAdded: [],
  audioFilesRemoved: [],
  loadingAudioFiles: false,
  errorAudioFiles: null
};

var getters = {
  getAudioFiles: function getAudioFiles(state) {
    return __WEBPACK_IMPORTED_MODULE_5_lodash_difference___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_union___default()(state.audioFiles, state.audioFilesAdded), state.audioFilesRemoved);
  },
  getAudioById: function getAudioById(state, getters) {
    return function (id) {
      return getters.getAudioFiles.find(function (item) {
        return item.uuid === id;
      }) || {};
    };
  }
};

var actions = {
  saveAudioFiles: function saveAudioFiles(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    var orgId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(rootState, 'authentication.currentOrgId');
    var url = '/orgs/' + orgId + '/files';
    var files = state.audioFilesAdded.map(function (f) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_pick___default()(f, ['uuid', 'fileType', 'friendlyName', 'uri', 'fileName']), { permanent: true });
    });
    var addPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["h" /* pMap */])(files, function (f) {
      return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.post('' + url, f);
    }, { concurrency: 5 });
    var removePromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["h" /* pMap */])(state.audioFilesRemoved, function (f) {
      return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.delete(url + '/' + f);
    }, { concurrency: 5 });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([addPromise, removePromise]);
  },
  getAudiosFromDuplicate: function getAudiosFromDuplicate(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;
    var audios = _ref3.audios;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], true);
    var transform = function transform(r) {
      return 'data:' + r.headers['content-type'] + ';base64,' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__base64__["a" /* base64ArrayBuffer */])(r.data);
    };
    var orgId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(rootState, 'authentication.currentOrgId');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["h" /* pMap */])(audios, function (audio) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([audio, __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get('/orgs/' + orgId + '/files/' + audio.uuid)]).then(function (tuple) {
        var _tuple = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(tuple, 2),
            snd = _tuple[0],
            audio = _tuple[1].data;

        return axiosExternal.get(audio.url, { responseType: 'arraybuffer' }).then(function (r) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, audio, { uuid: snd.newUuid }, { uri: transform(r) });
        });
      });
    }, { concurrency: 5 }).then(function (audios) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* SET_AUDIO_FILES_ADDED */], audios);
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* SET_AUDIO_FILES_ERROR */], { response: error.name, message: error.message });
    }).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], false);
    });
  },
  downloadAudioFiles: function downloadAudioFiles(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state,
        rootState = _ref4.rootState;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], true);
    var orgId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(rootState, 'authentication.currentOrgId');
    var campaignId = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(rootState, 'campaign.current.id');
    if (!campaignId) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* RESET_AUDIO_FILES */]);
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], false);
      return;
    }
    var url = '/orgs/' + orgId + '/files?campaignId=' + campaignId;
    __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(url).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(response.data.map(function (f) {
        return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get('/orgs/' + orgId + '/files/' + f.uuid);
      })).then(function (res) {
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* SET_AUDIO_FILES */], { data: res.data });
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], false);
      });
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], false);
      commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* SET_AUDIO_FILES_ERROR */], { response: error.name, message: error.message });
    });
  },
  addAudioFiles: function addAudioFiles(_ref5, audio) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* ADD_AUDIO_FILE */], { audio: audio });
  },
  removeAudioFiles: function removeAudioFiles(_ref6, audio) {
    var commit = _ref6.commit,
        state = _ref6.state;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* REMOVE_AUDIO_FILE */], { audio: audio });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* ADD_AUDIO_FILE */], function (state, _ref7) {
  var audio = _ref7.audio;

  state.audioFilesAdded.push(__WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(audio));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* REMOVE_AUDIO_FILE */], function (state, _ref8) {
  var audio = _ref8.audio;

  if (audio.id) {
    state.audioFilesRemoved.push(audio);
  } else {
    var index = state.audioFilesAdded.findIndex(function (v) {
      return v.uuid === audio.uuid;
    });
    if (index !== -1) {
      state.audioFilesAdded.splice(index, 1);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* SET_AUDIO_FILES */], function (state, audios) {
  state.audioFiles = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(audios);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* SET_AUDIO_FILES_ADDED */], function (state, audios) {
  state.audioFilesAdded = __WEBPACK_IMPORTED_MODULE_7_lodash_cloneDeep___default()(audios);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* RESET_AUDIO_FILES */], function (state) {
  state.audioFilesAdded = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* SET_AUDIO_FILES_LOADING */], function (state, value) {
  state.loadingAudioFiles = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* SET_AUDIO_FILES_ERROR */], function (state, value) {
  state.errorAudioFiles = value;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__feathers__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_intersection__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_includes__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_merge__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);




var _mutations;









var state = {
  currentUser: {
    data: null,
    error: null,
    loading: false
  },
  currentOrgId: null,
  roles: []
};

var getters = {
  hasRoles: function hasRoles(state) {
    return function (roles) {
      var userRoles = __WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(state.currentUser.data.organizations, { id: state.currentOrgId }).roles;
      return __WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(userRoles, 'superAdmin') ? true : __WEBPACK_IMPORTED_MODULE_6_lodash_intersection___default()(userRoles, roles).length > 0;
    };
  },
  availableRoles: function availableRoles(state) {
    if (state.currentUser && state.currentUser.data && state.currentUser.data.organizations && state.currentOrgId) {
      var org = state.currentUser.data.organizations.find(function (item) {
        return item.id === state.currentOrgId;
      });
      if (org && __WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(org.roles, 'superAdmin')) {
        return state.roles;
      } else if (org) {
        return state.roles.filter(function (role) {
          return __WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(org.roles, role.id);
        });
      }
    }
  }
};

var actions = {
  login: function login(_ref, _ref2) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    var email = _ref2.email,
        password = _ref2.password;

    var user = null;
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["I" /* LOGIN_USER_REQUEST */]);
    return __WEBPACK_IMPORTED_MODULE_4__feathers__["e" /* default */].authenticate({
      strategy: 'local',
      email: email,
      password: password
    }).then(function (response) {
      user = response.user;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__feathers__["e" /* default */].passport.verifyJWT(response.accessToken), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(response.accessToken)]);
    }).then(function (_ref3) {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
          payload = _ref4[0],
          jwt = _ref4[1];

      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.headers.common['Authorization'] = jwt;
      __WEBPACK_IMPORTED_MODULE_4__feathers__["e" /* default */].set('user', user);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["J" /* LOGIN_USER_SUCCESS */], { user: user });
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["K" /* SET_CURRENT_USER_ORGID */], { orgId: user.organizations[0].id });
      return __WEBPACK_IMPORTED_MODULE_4__feathers__["f" /* Users */].get(user.id, { orgId: user.organizations[0].id });
    }).then(function (res) {
      __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default()(user, res);
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["J" /* LOGIN_USER_SUCCESS */], { user: user });
      return user;
    }).catch(function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["L" /* LOGIN_USER_FAILURE */], { error: error });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState,
        dispatch = _ref5.dispatch;

    return __WEBPACK_IMPORTED_MODULE_4__feathers__["e" /* default */].logout().then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["M" /* RESET_CURRENT_USER */]);
      localStorage.removeItem('feathers-jwt');
      delete __WEBPACK_IMPORTED_MODULE_9_axios___default.a.defaults.headers.common['Authorization'];
      dispatch('reset', null, { root: true });
    });
  },
  getRoles: function getRoles(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    return __WEBPACK_IMPORTED_MODULE_4__feathers__["g" /* Roles */].find().then(function (roles) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["N" /* SET_ROLES */], { roles: roles });
    });
  },
  changeOrg: function changeOrg(_ref7, orgId) {
    var commit = _ref7.commit,
        state = _ref7.state,
        dispatch = _ref7.dispatch;

    if (!orgId) {
      orgId = state.currentOrgId;
    }
    var org = state.currentUser.data.organizations.find(function (u) {
      return Number(u.id) === Number(orgId);
    });
    commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["K" /* SET_CURRENT_USER_ORGID */], { orgId: orgId });
    if (org.logo) {
      dispatch('changeLogo', { orgId: orgId, orgLogo: org.logo });
    }
    if (org.title) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_CURRENT_TITLE */], org.title);
    } else {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* SET_CURRENT_TITLE */], 'IPCOM VORTEX');
    }
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["O" /* SET_CURRENT_USER */], function (state, _ref8) {
  var user = _ref8.user;

  state.currentUser.data = user;
  state.currentUser.error = null;
  state.currentUser.loading = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["K" /* SET_CURRENT_USER_ORGID */], function (state, _ref9) {
  var orgId = _ref9.orgId;

  if (state.currentOrgId !== orgId) {
    state.currentOrgId = orgId;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["I" /* LOGIN_USER_REQUEST */], function (state) {
  state.currentUser.loading = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["J" /* LOGIN_USER_SUCCESS */], function (state, _ref10) {
  var user = _ref10.user;

  state.currentUser.data = user;
  state.currentUser.error = null;
  state.currentUser.loading = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["L" /* LOGIN_USER_FAILURE */], function (state, _ref11) {
  var error = _ref11.error;

  state.currentUser.loading = false;
  state.currentUser.error = error;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["M" /* RESET_CURRENT_USER */], function (state) {
  state.currentUser = {
    data: {},
    error: null,
    loading: false
  };
  state.currentOrgId = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["P" /* RESET_CURRENT_USER_LOADING */], function (state) {
  state.currentUser.loading = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["N" /* SET_ROLES */], function (state, _ref12) {
  var roles = _ref12.roles;

  state.roles = roles;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_rest_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ajv__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ajv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ajv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialpan_schema_json__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dialpan_schema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__dialpan_schema_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);





var _mutations;




// import moment from 'moment'








var ajv = new __WEBPACK_IMPORTED_MODULE_8_ajv___default.a({ coerceTypes: true, removeAdditional: true });
ajv.addSchema(__WEBPACK_IMPORTED_MODULE_9__dialpan_schema_json___default.a, 'plan');
// const today = moment(new Date()).format('YYYY-MM-DD')

function defaultState() {
  return {
    status: null,
    tts: null,
    all: [],
    current: null,
    voices2: [],
    peers: [],
    currentVariables: null
  };
}

function defaultCampaign(state) {
  var num = state.all.length + 1;
  return {
    name: 'Campaign ' + num,
    concurrentCalls: 10,
    waitTime: 20,
    retryTime: 15,
    contactRate: 99,
    sipPeer: '',
    dialPrefix: '',
    answerMachineDetection: true,
    answerMachineDetectionHangUp: true,
    callerId: '',
    clientId: '',
    isdnRejectCodes: '',
    routeGroup: '',
    organization_id: 1,
    subscriber_db_id: null,
    maxAttempts: 3,
    minHour: null,
    open: null,
    maxHour: null,
    startDate: null,
    endDate: null,
    country: null,
    cps: 0,
    plan: {
      initialStep: {
        type: 'TTS',
        title: '',
        step: null,
        input: null,
        voice: null,
        transition: 0
      }
    }
  };
}

var module = new __WEBPACK_IMPORTED_MODULE_5_vuex_rest_api___default.a({
  baseURL: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].$backendBaseURL,
  state: defaultState()
}).get({
  action: 'listCampaigns',
  property: 'all',
  path: function path(_ref) {
    var orgId = _ref.orgId,
        _ref$query = _ref.query,
        query = _ref$query === undefined ? '' : _ref$query;
    return '/orgs/' + orgId + '/campaigns' + query;
  }
}).get({
  action: 'getCampaign',
  property: 'current',
  path: function path(_ref2) {
    var orgId = _ref2.orgId,
        id = _ref2.id;
    return '/orgs/' + orgId + '/campaigns/' + id;
  }
}).get({
  action: 'listPeers',
  property: 'peers',
  path: '/peers'
}).post({
  action: 'createCampaign',
  property: 'current',
  path: function path(_ref3) {
    var orgId = _ref3.orgId;
    return '/orgs/' + orgId + '/campaigns';
  },
  onError: function onError(state, error) {
    state.pending.current = false;
    state.error.current = error;
    return error;
  }
}).put({
  action: 'updateCampaign',
  property: 'current',
  path: function path(_ref4) {
    var orgId = _ref4.orgId,
        id = _ref4.id;
    return '/orgs/' + orgId + '/campaigns/' + id;
  },
  onError: function onError(state, error) {
    state.pending.current = false;
    state.error.current = error;
    return error;
  }
}).patch({
  action: 'patchCampaign',
  property: 'current',
  path: function path(_ref5) {
    var orgId = _ref5.orgId,
        id = _ref5.id;
    return '/orgs/' + orgId + '/campaigns/' + id;
  }
}).get({
  action: 'listVoices2',
  property: 'voices2',
  path: '/voices2'
}).get({
  action: 'getCampaignReportAnswers',
  property: 'reportAnswers',
  path: function path(_ref6) {
    var orgId = _ref6.orgId,
        campaignId = _ref6.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/reports/answers';
  }
}).get({
  action: 'getCampaignReportMinutes',
  property: 'reportMinutes',
  path: function path(_ref7) {
    var orgId = _ref7.orgId,
        campaignId = _ref7.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/reports/minutes';
  }
}).get({
  action: 'getCampaignReportDisposition',
  property: 'reportDisposition',
  path: function path(_ref8) {
    var orgId = _ref8.orgId,
        campaignId = _ref8.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/reports/disposition';
  }
}).get({
  action: 'getCampaignReportAttempts',
  property: 'reportAttempts',
  path: function path(_ref9) {
    var orgId = _ref9.orgId,
        campaignId = _ref9.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/reports/attempts';
  }
}).patch({
  action: 'patchCampaignStatus',
  property: 'status',
  path: function path(_ref10) {
    var orgId = _ref10.orgId,
        campaignId = _ref10.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/status';
  }
}).patch({
  action: 'patchCampaignTTS',
  property: 'tts',
  path: function path(_ref11) {
    var orgId = _ref11.orgId,
        campaignId = _ref11.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/TTS';
  }
}).put({
  action: 'updateCampaignTTS',
  property: 'current',
  path: function path(_ref12) {
    var orgId = _ref12.orgId,
        campaignId = _ref12.campaignId;
    return '/orgs/' + orgId + '/campaigns/' + campaignId + '/TTS';
  }
}).getStore();

var state = {
  duplicate: false
};

var getters = {
  lastCampaigns: function lastCampaigns(state) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["orderBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["take"])(state.all, 50), ['id'], ['desc']);
  },
  openCampaigns: function openCampaigns(state) {
    if (Array.isArray(state.all)) {
      return state.all.filter(function (c) {
        return c.open && c.state !== 'draft' && c.state !== 'finished';
      });
    }
  },
  subscriberDbId: function subscriberDbId(state) {
    if (state.current) return state.current.subscriber_db_id;
  },
  initialStep: function initialStep(state) {
    if (state.current && state.current.plan) return state.current.plan.initialStep;
  },
  voices: function voices(state) {
    return state.voices;
  },
  voices2: function voices2(state) {
    return state.voices2.map(function (voice) {
      var languageCode = voice.languageCode;
      switch (voice.languageCode) {
        case 'cmn-CN':
          languageCode = 'zh-CN';
          break;
        case 'arb':
          languageCode = 'ar';
          break;
      }
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, voice, { languageCode: languageCode });
    });
  },
  peers: function peers(state) {
    return state.peers;
  },
  campaignById: function campaignById(state) {
    return function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["defaults"])(state.all.find(function (item) {
        return item.id === id;
      }), {
        endDate: new Date().toISOString().substring(0, 10),
        maxAttempts: 5,
        concurrentCalls: 99
      });
    };
  },
  variables: function variables(state) {
    return state.currentVariables;
  },


  // pagination getters
  page: function page(state) {
    return state.page;
  },
  size: function size(state) {
    return state.size;
  }
};

function getAllAudios(initStep) {
  var sounds = [];
  var audioProps = ['preAudio', 'postAudio', 'audio', 'repeatPreAudio', 'invalidAudio'];
  var traverse = function traverse(obj) {
    var nextObj = obj['step'] || obj['input'];
    if (nextObj) {
      traverse(nextObj);
    }
    if (obj['choices'] && Array.isArray(obj['choices'])) {
      obj['choices'].forEach(function (v) {
        if (v['step']) traverse(v['step']);
      });
    }

    var _loop = function _loop(k) {
      if (!obj[k]) {
        return 'continue';
      }
      var snd = sounds.find(function (s) {
        return s.uuid === obj[k];
      });
      if (snd) {
        obj[k] = snd.newUuid;
      } else {
        var tmpsnd = { uuid: obj[k], newUuid: __WEBPACK_IMPORTED_MODULE_11_uuid___default()() };
        obj[k] = tmpsnd.newUuid;
        sounds.push(tmpsnd);
      }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(audioProps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var k = _step.value;

        var _ret = _loop(k);

        if (_ret === 'continue') continue;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };
  traverse(initStep);
  return sounds;
}

function mapVoiceToVoice2(initStep) {
  var traverse = function traverse(obj) {
    var nextObj = obj['step'] || obj['input'];
    if (nextObj) {
      traverse(nextObj);
    }
    if (obj['choices'] && Array.isArray(obj['choices'])) {
      obj['choices'].forEach(function (v) {
        if (v['step']) traverse(v['step']);
      });
    }
    var voiceId = obj['voice'];
    if (!voiceId) {
      return;
    }
    obj['voice2'] = convertVoice(voiceId);
  };
  traverse(initStep);
}

function convertVoice(VoiceId) {
  var id = parseInt(VoiceId) - 1;
  if (id < 0 || id > 15) {
    return null;
  }
  var voice = [['Miguel', 'es-US'], ['Conchita', 'es-ES'], ['Penelope', 'en-US'], ['Enrique', 'es-ES'], ['Ricardo', 'pt-BR'], ['Vitoria', 'pt-BR'], ['Cristiano', 'pt-PT'], ['Ines', 'pt-PT'], ['Mia', 'es-MX'], ['Lucia', 'it-IT'], ['Lupe', 'es-US'], ['Joanna', 'en-US'], ['Kendra', 'en-US'], ['Kimberly', 'en-US'], ['Joey', 'en-US'], ['Matthew', 'en-US']][id];
  return {
    provider: 'aws',
    voiceCode: voice[0],
    languageCode: voice[1],
    voiceName: voice[0],
    premium: false
  };
}

var actions = {
  updateCampaignPlan: function updateCampaignPlan(_ref13) {
    var commit = _ref13.commit,
        rootState = _ref13.rootState;

    var tree = rootState.dialplan.tree;
    var plan = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* transformPlan */])(tree);
    if (ajv.validate('plan', plan)) commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* SET_CAMPAIGN_PLAN */], { plan: plan });
  },
  cloneCampaign: function cloneCampaign(_ref14, _ref15) {
    var commit = _ref14.commit,
        state = _ref14.state,
        dispatch = _ref14.dispatch;
    var campaignId = _ref15.campaignId;

    var campaign = state.all.data.find(function (c) {
      return c.id === campaignId;
    });
    if (!campaign) return;

    var step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["cloneDeep"])(campaign.plan.initialStep);
    mapVoiceToVoice2(step);
    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["omit"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["cloneDeep"])(step), 'voice');
    var audios = getAllAudios(step);
    var newcampaign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["omit"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["cloneDeep"])(campaign), 'id');
    newcampaign.plan.initialStep = step;
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* SET_CURRENT_CAMPAIGN */], { campaign: newcampaign });
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* SET_DIALPLAN_FROM_STEP */], { step: step });
    dispatch('getAudiosFromDuplicate', { audios: audios });
    __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push({ path: '/admin/campaigns/new' });
  },
  reset: function reset(_ref16) {
    var commit = _ref16.commit,
        rootState = _ref16.rootState;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* RESET_CURRENT_CAMPAIGN */]);
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* RESET_CAMPAIGNS */]);
  }
};

// Save reference to the Vapi-generated listCampaigns action so we can wrap it
var _vapiListCampaigns = module.actions && module.actions.listCampaigns ? module.actions.listCampaigns : null;

// Wrap/override the listCampaigns action to update pagination in the store
// before delegating to the original Vapi action. This keeps callers unchanged
// (they still call `listCampaigns`) while ensuring the store holds the
// current page/size each time a fetch is made.
actions.listCampaigns = function (_ref17, payload) {
  var commit = _ref17.commit,
      dispatch = _ref17.dispatch,
      state = _ref17.state,
      rootState = _ref17.rootState,
      getters = _ref17.getters;

  var page = state.page || 1;
  var size = state.size || 10;

  commit('SET_CAMPAIGN_PAGINATION', { page: page, size: size });

  if (_vapiListCampaigns) {
    // Call the original Vapi-generated action with the same context and payload
    return _vapiListCampaigns({ commit: commit, dispatch: dispatch, state: state, rootState: rootState, getters: getters }, payload);
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* SET_CAMPAIGN_PLAN */], function (state, _ref18) {
  var plan = _ref18.plan;

  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(state.current, 'plan', plan);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_CAMPAIGN_PAGINATION', function SET_CAMPAIGN_PAGINATION(state, _ref19) {
  var page = _ref19.page,
      size = _ref19.size;

  state.page = page;
  state.size = size;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_CAMPAIGN_PAGE', function SET_CAMPAIGN_PAGE(state, page) {
  state.page = page;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_CAMPAIGN_SIZE', function SET_CAMPAIGN_SIZE(state, size) {
  state.size = size;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* SET_CURRENT_CAMPAIGN */], function (state, _ref20) {
  var campaign = _ref20.campaign;

  state.current = campaign;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* SET_DB_VARIABLES */], function (state, _ref21) {
  var value = _ref21.value;

  state.currentVariables = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* RESET_CAMPAIGNS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(state, defaultState());
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* RESET_CURRENT_CAMPAIGN */], function (state) {
  state.current = defaultCampaign(state);
  state.pending = {
    current: false
  };
  state.error = {
    current: null
  };
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash__["merge"])(module, {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_assign__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniq__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_pick__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_keys__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_defaults__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_defaults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid_v4__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(13);



var _mutations;














var createTreeFromStep = function createTreeFromStep(initialStep) {
  var tree = { initialStep: initialStep };
  var parentId = null;
  (function recurse(currentStep) {
    if (currentStep.type === 'SimpleAction') {
      __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default()(currentStep, {
        hangup: {
          type: 'Hangup',
          title: 'Hangup'
        },
        begin: {
          type: 'Begin',
          title: 'Begin'
        },
        return: {
          type: 'Return',
          title: 'Return'
        },
        repeat: {
          type: 'Repeat',
          title: 'Repeat'
        }
      }[currentStep.action]);
    }

    currentStep.id = __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default()();
    currentStep.parentId = parentId;
    parentId = currentStep.id;
    __WEBPACK_IMPORTED_MODULE_11_lodash_defaults___default()(currentStep, { input: null, step: null });

    if (currentStep.step) {
      recurse(currentStep.step);
    } else if (currentStep.input) {
      currentStep.input.choices.map(function (item) {
        return recurse(item.step);
      });
    } else {}
    return currentStep;
  })(initialStep);

  return tree;
};

var traverse = function traverse(tree, callback) {
  (function recurse(currentStep) {
    if (currentStep.step) {
      recurse(currentStep.step);
    } else if (currentStep.input) {
      currentStep.input.choices.map(function (item) {
        return recurse(item.step);
      });
    }
    callback(currentStep);
  })(tree.initialStep);
};

var updateTree = function updateTree(tree, data) {
  if (tree) {
    traverse(tree, function (step) {
      if (step.id === data.id) {
        __WEBPACK_IMPORTED_MODULE_10_lodash_mapKeys___default()(step, function (value, key) {
          if (!__WEBPACK_IMPORTED_MODULE_8_lodash_has___default()(data, key)) delete step[key];
        });
        __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default()(step, data);
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_13_vue__["default"].set(state, 'tree', tree);
};

var state = {
  tree: null,
  currentStep: null
};

var getters = {
  tree: function tree(state) {
    return state.tree;
  },
  currentStep: function currentStep(state) {
    return state.currentStep;
  },
  step: function step(state, getters) {
    if (getters.currentStep) return state.currentStep.step;
  },
  input: function input(state, getters) {
    if (getters.currentStep) return state.currentStep.input;
  },
  stepById: function stepById(state) {
    return function (id) {
      var res = void 0;
      traverse(state.tree, function (step) {
        if (step.id === id) return res = step;
      });
      return res;
    };
  },
  genStepTitle: function genStepTitle(state) {
    return function (step) {
      // let title = step.title
      // if (state.tree && isEmpty(title)) {
      //   let types = []
      //   traverse(state.tree, function (step) {
      //     types.push(step.type)
      //   })
      //   const count = countBy(types)[step.type]
      //   title = `${step.type} ${count || '1'}`
      // }
      return step.title;
    };
  },
  breadCrumbs: function breadCrumbs(state, getters) {
    var array = [];
    if (state.tree && state.currentStep) {
      array.push(state.currentStep);
      var parentId = state.currentStep.parentId;
      while (parentId) {
        var step = getters.stepById(parentId);
        array.unshift(step);
        parentId = step.parentId;
      }
    }
    return array;
  },
  isSimpleAction: function isSimpleAction(state, getters) {
    return function () {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default()(['Hangup', 'Begin', 'Return', 'Repeat'], getters.step.type);
    };
  }
};

var actions = {
  navigate: function navigate(_ref, _ref2) {
    var commit = _ref.commit,
        getters = _ref.getters;
    var id = _ref2.id,
        campaignId = _ref2.campaignId;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        var data = getters.stepById(id);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: '/admin/campaigns/' + (campaignId || '') + (campaignId ? '/edit' : 'new') + '/' + id });
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_DIALPLAN_CURRENT_STEP */], { data: data });
        resolve(data);
      });
    });
  },
  initDialplan: function initDialplan(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        getters = _ref3.getters;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* SET_DIALPLAN_FROM_STEP */], { step: getters.initialStep });
  },
  setCurrentStepObject: function setCurrentStepObject(_ref4, object) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var props = __WEBPACK_IMPORTED_MODULE_5_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_keys___default()(object).concat(['id', 'parentId', 'step', 'input', 'type']));
    var data = __WEBPACK_IMPORTED_MODULE_4_lodash_assign___default()(object, __WEBPACK_IMPORTED_MODULE_7_lodash_pick___default()(state.currentStep, props));
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_DIALPLAN_CURRENT_STEP */], { data: data });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["u" /* SET_DIALPLAN_FROM_STEP */], function (state, _ref5) {
  var step = _ref5.step;

  state.tree = createTreeFromStep(step);
  state.currentStep = state.tree.initialStep;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* SET_DIALPLAN_CURRENT_STEP */], function (state, _ref6) {
  var data = _ref6.data;

  if (!data.id) data.id = __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default()();
  state.currentStep = data;
  updateTree(state.tree, state.currentStep);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* SET_DIALPLAN_NEXT_STEP */], function (state, _ref7) {
  var step = _ref7.step;

  if (state.currentStep) {
    if (!step.id) {
      step.id = __WEBPACK_IMPORTED_MODULE_12_uuid_v4___default()();
      step.parentId = state.currentStep.id;
    }
    step.step = step.step;
    step.input = step.input;
    state.currentStep.step = step;
    updateTree(state.tree, state.currentStep);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SET_DIALPLAN_INPUT */], function (state, _ref8) {
  var input = _ref8.input;

  if (state.currentStep) {
    state.currentStep.input = input;
    updateTree(state.tree, state.currentStep);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* RESET_DIALPLAN_STATE */], function (state) {
  state = {
    tree: null,
    currentStep: null
  };
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_rest_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_merge__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_merge__);






var module = new __WEBPACK_IMPORTED_MODULE_3_vuex_rest_api___default.a({
  baseURL: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$backendBaseURL,
  state: {
    all: [],
    current: null,
    audios: []
  }
}).get({
  action: 'listFiles',
  property: 'all',
  path: function path(_ref) {
    var orgId = _ref.orgId;
    return '/orgs/' + orgId + '/files';
  }
}).get({
  action: 'getFile',
  property: 'current',
  path: function path(_ref2) {
    var orgId = _ref2.orgId,
        id = _ref2.id;
    return '/orgs/' + orgId + '/files/' + id;
  }
}).post({
  action: 'createFile',
  property: 'current',
  path: function path(_ref3) {
    var orgId = _ref3.orgId;
    return '/orgs/' + orgId + '/files';
  }
}).put({
  action: 'updateFile',
  property: 'current',
  path: function path(_ref4) {
    var orgId = _ref4.orgId,
        id = _ref4.id;
    return '/orgs/' + orgId + '/files/' + id;
  }
}).getStore();

var state = {};

var getters = {
  audioList: function audioList(state) {
    return state.all.filter(function (item) {
      return item.fileType === 'audio';
    });
  },
  audioById: function audioById(state) {
    return function (id) {
      return state.all.find(function (item) {
        return item.uuid === id;
      }) || {};
    };
  }
};

var actions = {
  transformUserRoles: function transformUserRoles(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState;

    var roles = state.current.roles.map(function (item) {
      if (item.organizationId === rootState.authentication.currentOrgId) {
        return item.roleId;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* SET_USER_ROLES */], { roles: roles });
  }
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["w" /* RESET_FILE_STATE */], function (state) {
  state.all = [];
  state.current = null;
  state.pending = {
    all: false,
    current: false
  };
  state.error = {
    all: null,
    current: null
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_lodash_merge___default()(module, {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_i18n__ = __webpack_require__(458);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vuex_i18n__["a" /* default */].store);

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(13);


var _mutations;







var module = new __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default.a({
  baseURL: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$backendBaseURL,
  state: {
    all: [],
    current: {}
  }
}).get({
  action: 'listOrgs',
  property: 'all',
  path: '/orgs',
  queryParams: true
}).get({
  action: 'getOrg',
  property: 'current',
  path: function path(_ref) {
    var id = _ref.id;
    return '/orgs/' + id;
  }
}).post({
  action: 'createOrg',
  property: 'current',
  path: '/orgs'
}).put({
  action: 'updateOrg',
  property: 'current',
  path: function path(_ref2) {
    var id = _ref2.id;
    return '/orgs/' + id;
  }
}).get({
  action: 'cps',
  property: 'current',
  path: function path(_ref3) {
    var id = _ref3.id;
    return '/orgs/' + id + '/cps';
  }
}).put({
  action: 'cps',
  property: 'current',
  path: function path(_ref4) {
    var id = _ref4.id;
    return '/orgs/' + id + '/cps';
  }
}).getStore();

var state = {};

var getters = {
  getOrgById: function getOrgById(state) {
    return function (id) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["defaults"])(state.all.find(function (item) {
        return item.id === id;
      }), {
        prefix: null,
        maxAttempts: null,
        maxChannels: null
      });
    };
  }
};

var actions = {
  reset: function reset(_ref5) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["B" /* RESET_ORG_STATE */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["B" /* RESET_ORG_STATE */], function (state) {
  state.all = [];
  state.current = {};
  state.pending = {
    all: false,
    current: false
  };
  state.error = {
    all: null,
    current: null
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* RESET_ORG_CURRENT */], function (state) {
  state.current = {};
  state.pending.current = false;
  state.error.current = null;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["merge"])(module, {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(13);







var module = new __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default.a({
  baseURL: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$backendBaseURL,
  state: {
    all: [],
    current: {}
  }
}).get({
  action: 'listSubscriberDb',
  property: 'all',
  path: function path(_ref) {
    var orgId = _ref.orgId;
    return '/orgs/' + orgId + '/subscriber_db';
  }
}).get({
  action: 'getSubscriberDb',
  property: 'current',
  path: function path(_ref2) {
    var orgId = _ref2.orgId,
        id = _ref2.id;
    return '/orgs/' + orgId + '/subscriber_db/' + id;
  }
}).post({
  action: 'createSubscriberDb',
  property: 'current',
  path: function path(_ref3) {
    var orgId = _ref3.orgId;
    return '/orgs/' + orgId + '/subscriber_db';
  }
}).put({
  action: 'updateSubscriberDb',
  property: 'current',
  path: function path(_ref4) {
    var orgId = _ref4.orgId,
        id = _ref4.id;
    return '/orgs/' + orgId + '/subscriber_db/' + id;
  }
}).getStore();

var state = {};

var getters = {};

var actions = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["A" /* RESET_SDB_STATE */], function (state) {
  state.all = [];
  state.current = null;
  state.pending = {
    all: false,
    current: false
  };
  state.error = {
    all: null,
    current: null
  };
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(module, {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(13);


var _mutations;






var module = new __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default.a({
  baseURL: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$backendBaseURL,
  state: {
    all: [{
      name: 'tourDashboard',
      viewed: true
    }, {
      name: 'tourOrg',
      viewed: true
    }, {
      name: 'tourSuscribers',
      viewed: true
    }, {
      name: 'tourUpload',
      viewed: true
    }, {
      name: 'tourImport',
      viewed: true
    }, {
      name: 'tourCampaign',
      viewed: true
    }, {
      name: 'tourStep1',
      viewed: true
    }, {
      name: 'tourStep2',
      viewed: true
    }, {
      name: 'tourStep3',
      viewed: true
    }, {
      name: 'tourStep4',
      viewed: true
    }, {
      name: 'tourUsers',
      viewed: true
    }],
    current: {
      name: '',
      data: null,
      viewed: true
    },
    activeHelp: false
  }
}).getStore();

var state = {};

var getters = {
  getTourByName: function getTourByName(state) {
    return function (name) {
      return state.all.find(function (item) {
        return item.name === name;
      });
    };
  },
  setViewedOff: function setViewedOff(state) {
    return function (name) {
      return state.all.find(function (item) {
        return item.name === name;
      });
    };
  }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["C" /* RESET_TOUR_STATE */], function (state) {
  state.current = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["D" /* UPDATE_CURRENT_TOUR */], function (state, _ref) {
  var tour = _ref.tour;

  state.current = tour;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["E" /* SET_VIEWED_VALUE */], function (state, value) {
  var result = state.all.find(function (item) {
    return item.name === value;
  });
  result.viewed = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["F" /* CHANGE_ACTIVE_HELP */], function (state, value) {
  state.activeHelp = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* UPDATE_CURRENT_TOUR_DATA */], function (state, value) {
  state.current = { data: value };
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()(module, {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_rest_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(13);


var _mutations;







var initialUserState = {
  all: [],
  current: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phone: '',
    cellPhone: '',
    position: '',
    cardId: '',
    roles: [],
    orgs: [],
    active: true,
    photo: null
  }
};

var module = new __WEBPACK_IMPORTED_MODULE_2_vuex_rest_api___default.a({
  baseURL: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].$backendBaseURL,
  state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(initialUserState)
}).get({
  action: 'listUsers',
  property: 'all',
  path: function path(_ref) {
    var orgId = _ref.orgId;
    return '/orgs/' + orgId + '/users';
  }
}).get({
  action: 'getUser',
  property: 'current',
  path: function path(_ref2) {
    var orgId = _ref2.orgId,
        id = _ref2.id;
    return '/orgs/' + orgId + '/users/' + id;
  }
}).post({
  action: 'createUser',
  property: 'current',
  path: function path(_ref3) {
    var orgId = _ref3.orgId;
    return '/orgs/' + orgId + '/users';
  }
}).put({
  action: 'updateUser',
  property: 'current',
  path: function path(_ref4) {
    var orgId = _ref4.orgId,
        id = _ref4.id;
    return '/orgs/' + orgId + '/users/' + id;
  },
  onError: function onError(state, error) {}
}).getStore();

var state = {};

var getters = {};

var actions = {
  transformUserRoles: function transformUserRoles(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState;

    var roles = state.current.roles.map(function (item) {
      if (item.organizationId === rootState.authentication.currentOrgId) {
        return item.roleId;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* SET_USER_ROLES */], { roles: roles });
  },
  reset: function reset(_ref6) {
    var commit = _ref6.commit,
        rootState = _ref6.rootState;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["G" /* RESET_USER_STATE */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["G" /* RESET_USER_STATE */], function (state) {
  state.all = [];
  state.current = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["cloneDeep"])(initialUserState);
  state.pending = {
    all: false,
    current: false
  };
  state.error = {
    all: null,
    current: null
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* RESET_USER_CURRENT */], function (state) {
  state.current = null;
  state.pending.current = false;
  state.error.current = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["v" /* SET_USER_ROLES */], function (state, _ref7) {
  var roles = _ref7.roles;

  state.current.roles = roles;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["H" /* TMP */], function (state) {
  delete state.current.photo;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["merge"])(module, {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base64__ = __webpack_require__(239);


var _mutations;





var state = {
  globalLogo: null,
  globalTitle: null,
  currentLogo: '/static/img/logo.svg',
  currentTitle: 'IPCOM VORTEX'
};

var getters = {
  currentLogoUrl: function currentLogoUrl(state) {
    if (state.currentLogo !== '/static/img/logo.svg') {
      return state.currentLogo;
    }
    if (state.globalLogo) {
      return state.globalLogo;
    }
    return '/static/img/logo.svg';
  },
  currentSoftwareTitle: function currentSoftwareTitle(state) {
    if (state.currentTitle !== 'IPCOM VORTEX') {
      return state.currentTitle;
    }
    if (state.globalTitle) {
      return state.globalTitle;
    }
    return 'IPCOM VORTEX';
  }
};

var actions = {
  changeLogo: function changeLogo(_ref, _ref2) {
    var commit = _ref.commit;
    var orgId = _ref2.orgId,
        orgLogo = _ref2.orgLogo;

    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: '/orgs/' + orgId + '/files/' + orgLogo
    }).then(function (response) {
      return response.data.url;
    }).then(function (url) {
      var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({ baseURL: '', headers: { common: [] } });
      delete instance.defaults.headers.common['Authorization'];
      return instance({
        url: url,
        method: 'get',
        responseType: 'arraybuffer'
      });
    }).then(function (response) {
      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__base64__["a" /* base64ArrayBuffer */])(response.data);
      return 'data:' + response.headers['content-type'] + ';base64,' + data;
    }).then(function (url) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* SET_CURRENT_LOGO */], url);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* SET_CURRENT_LOGO */], function (state, logo) {
  state.currentLogo = logo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["m" /* SET_CURRENT_TITLE */], function (state, title) {
  state.currentTitle = title;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_GLOBAL_LOGO */], function (state, logo) {
  state.globalLogo = logo;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* SET_GLOBAL_TITLE */], function (state, title) {
  state.globalTitle = title;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_base64_file_upload__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_base64_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_base64_file_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tour_dist_tour_js__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tour_dist_tour_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tour_dist_tour_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(101);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







if (!__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization']) __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = localStorage.getItem('feathers-jwt');

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      speedDial: false,
      routesFalse: ['Main', 'Login'],
      currentUserData: {},
      snackbar: {
        errors: [],
        events: []
      },
      audioFormIsVisible: false,
      fileData: {
        fileName: '',
        uri: '',
        fileType: 'audio',
        friendlyName: '',
        size: 0
      },
      fileName: '',
      customImageMaxSize: 3, // megabytes
      search: '',
      nombreElemento: '',
      buttonSave: true,
      dialogTemp: '',
      dialogMessage: ' ',
      snackbarMessage: ' ',
      snackbarStyle: 'md-primary',
      vertical: 'bottom',
      horizontal: 'center',
      duration: 3000
    };
  },
  components: {
    VueBase64FileUpload: __WEBPACK_IMPORTED_MODULE_1_vue_base64_file_upload___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    currentOrgId: function currentOrgId(state) {
      return state.authentication.currentOrgId;
    }
  }), {
    dMessage: function dMessage() {
      return this.dialogMessage;
    },
    sMessage: function sMessage() {
      return this.snackbarMessage;
    }
  }),
  created: function created() {
    this.$store.dispatch('getRoles');
    this.local = this.$i18n.locale();
    this.$validator.localize(this.local);
    this.$material.setCurrentTheme('global');
    this.$store.dispatch('listPeers');
  },
  mounted: function mounted() {
    var _this = this;

    this.$events.$on('snackbar-message', function (eventData) {
      _this.snackbarMessage = eventData.message;
      _this.snackbarStyle = eventData.style;
      _this.$refs.snackbar.open();
    });
    this.$events.$on('open-dialog', function (eventData) {
      _this.dialogTemp = eventData.return;
      _this.dialogMessage = eventData.message;
      if (eventData.element) {
        _this.openDialog(eventData.element);
      }
    });
    this.$events.$on('active-help', function (eventData) {
      _this.activeHelp(eventData);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$events.$off('active-help');
    this.$events.$off('open-dialog');
    this.$events.$off('snackbar-message');
  },

  methods: {
    isMobileDevice: function isMobileDevice() {
      // return true
      return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
    },
    activeHelp: function activeHelp(value) {
      this.$store.commit('CHANGE_ACTIVE_HELP', value);
      if (this.$store.state.tour.activeHelp) {
        this.runTourNow(this.$store.state.tour.current.data);
      }
    },
    runTourNow: function runTourNow(data) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_tour_dist_tour_js___default.a.start(data).then(function () {
        _this2.$store.commit('CHANGE_ACTIVE_HELP', false);
        _this2.$store.commit('SET_VIEWED_VALUE', data.name);
      }).catch(function (value) {
        _this2.$events.$emit('close-user-card', true);
        _this2.$store.commit('CHANGE_ACTIVE_HELP', false);
        _this2.$store.commit('SET_VIEWED_VALUE', data.name);
      });
    },
    openDialog: function openDialog(ref) {
      if (ref) {
        this.$refs[ref].open();
      }
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    },
    onClose: function onClose(type) {
      if (type === 'ok') {
        this.$events.$emit(this.dialogTemp, true);
      }
    },
    open: function open() {
      this.$refs.snackbar.open();
    }
  }
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer',
  props: {
    name: String
  },
  data: function data() {
    return {};
  },

  computed: {
    softwareName: function softwareName() {
      return this.name + ', ©' + this.currentYear;
    },
    currentYear: function currentYear() {
      return new Date().getFullYear();
    }
  }
});

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_split__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_footer__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_main_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_main_footer__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageTitle: String
  },
  components: {
    MainFooter: __WEBPACK_IMPORTED_MODULE_3__components_main_footer___default.a
  },
  data: function data() {
    return {
      local: this.$i18n.locale()
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    versionNumber: function versionNumber() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_split___default()(' $Id: f3c82760b8987501919456117e4518bd5e5a18d5 $ ', ' ')[2].slice(-4);
    },
    isActiveHelp: function isActiveHelp() {
      return this.$store.state.tour.activeHelp;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    currentOrgId: function currentOrgId(state) {
      return state.authentication.currentOrgId;
    },
    organizations: function organizations(state) {
      return state.authentication.currentUser.data.organizations;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    softwareTitle: 'currentSoftwareTitle'
  })),
  mounted: function mounted() {
    var _this = this;

    document.title = this.pageTitle + ' - ' + this.softwareTitle;
    this.$events.$on('open-lang-card', function (value) {
      _this.$refs.langCard.open();
    });
    this.$events.$on('close-lang-card', function (value) {
      _this.$refs.langCard.close();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$events.$off('open-lang-card');
    this.$events.$off('close-lang-card');
  },

  methods: {
    toggleSidenav: function toggleSidenav() {
      this.$events.$emit('toggleSidenav');
    },
    setLocale: function setLocale(locale) {
      this.$i18n.set(locale);
      this.local = locale;
      this.$validator.localize(locale);
    },
    getLocale: function getLocale(locale) {
      if (this.$i18n.locale() === locale) {
        return true;
      } else {
        return false;
      }
    },
    activeHelp: function activeHelp() {
      if (this.$store.state.tour.activeHelp === true) {
        this.$events.$emit('active-help', false);
      } else {
        this.$events.$emit('active-help', true);
      }
    }
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_pick__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidenav',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    logoOrg: String,
    loadingLogo: Boolean
  },
  data: function data() {
    return {
      currentOrgIdTest: '',
      value: 1,
      image: null,
      imageId: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    currentUser: function currentUser(state) {
      return state.authentication.currentUser.data;
    },
    currentOrgId: function currentOrgId(state) {
      return state.authentication.currentOrgId;
    }
  }), {
    logoOrganization: function logoOrganization() {
      return this.logoOrg;
    },
    currentUserName: function currentUserName() {
      return this.currentUser.firstName + ' ' + this.currentUser.lastName;
    },

    currentOrgId: {
      get: function get() {
        var orgId = this.$store.state.authentication.currentOrgId;
        var list = this.currentUser.organizations;
        return { id: orgId, name: __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(list, { 'id': orgId }).name };
      },
      set: function set(value) {
        var id = value.id;
        this.$store.dispatch('changeOrg', id);
      }
    },
    orgSmallList: function orgSmallList() {
      var temp = [];
      for (var n in this.currentUser.organizations) {
        temp.push(__WEBPACK_IMPORTED_MODULE_4_lodash_pick___default()(this.currentUser.organizations[n], ['id', 'name']));
      }
      return temp;
    }
  }),
  methods: {
    toggleSidenav: function toggleSidenav() {
      if (this.$refs['main-sidebar']) {
        this.$refs['main-sidebar'].toggle();
      }
    },
    closeSidenav: function closeSidenav() {
      if (this.$refs['main-sidebar']) {
        this.$refs['main-sidebar'].close();
      }
    },
    logout: function logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    customLabel: function customLabel(_ref) {
      var name = _ref.name,
          id = _ref.id;

      return '' + name;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$events.$on('toggleSidenav', function () {
      return _this.toggleSidenav();
    });
    this.$events.$on('closeSidenav', function () {
      return _this.closeSidenav();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$events.$off('toggleSidenav');
    this.$events.$off('closeSidenav');
  }
});

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[573]);


// WEBPACK FOOTER //
// static/js/app.d1d1f150dd1c60686736.js